var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "2 0 900 315",
    width: "174px",
    height: "40px",
    strokeWidth: 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M0 0L0 137L1 137C2.35458 71.3715 70.1738 2.35892 136 1C125.258 -3.50748 106.682 0 95 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M136 0L136 1L140 1L136 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M140 0L140 1L144 1L140 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M304 183C291.137 185.976 269.144 190.465 258.498 198.278C255.115 200.761 253.607 206.445 251.573 210C247.097 217.82 241.864 225.298 235.829 232C213.597 256.693 180.95 269.793 148 268.985C135.075 268.669 121.864 264.911 110 259.988C98.1186 255.058 87.6996 247.77 78.0008 239.421C13.9545 184.284 37.3196 76.534 115 48.0532C153.479 33.9452 196.113 42.4158 227 69.2894C235.436 76.6291 242.664 85.5249 248.575 95C251.568 99.7982 253.75 107.287 257.815 111.157C261.128 114.311 267.753 115.251 272 116.667C282.555 120.185 293.159 124.492 304 127C291.835 80.0027 267.485 39.899 223 16.7839C162.794 -14.5 85.5781 -0.273438 40.1698 50C13.5629 79.4575 -0.466747 118.439 0.00385802 158C1.32953 269.443 122.561 343.456 222 293.73C267.098 271.178 291.808 230.102 304 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M162 0L162 1L166 1L162 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M166 0L166 1L170 1L166 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M170 0L170 1C232.637 1.51843 299.078 66.1481 304 128C290.735 122.12 269.236 120.922 258.225 111.49C250.384 104.775 246.209 90.3231 239.384 82C221.196 59.8203 192.084 43.3149 163 42.0394C129.181 40.5561 95.7582 50.671 72.0895 76.0008C12.8751 139.371 44.6788 251.72 133 266.565C171.103 272.969 209.515 260.383 235.91 232C244.637 222.617 248.983 206.425 258.225 198.51C269.236 189.078 290.735 187.88 304 182C299.078 243.851 232.646 308.481 170 309L170 310L1013 310L1013 28L1012 28L986.692 100L975.301 129.397L957 131L972 87L923 87L912.053 119L906.722 129.972L889 131L916.192 54L926.702 26.6034L945 25L930 69L965 69C968.605 69 975.248 70.2598 978.298 67.9722C989.168 59.8198 983.974 33.6317 995.419 26.0278C999.502 23.3149 1008.25 25 1013 25L1013 0L170 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M129.667 1.33334L130.333 1.66666L129.667 1.33334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M131.667 1.33334L132.333 1.66666L131.667 1.33334M173.667 1.33334L174.333 1.66666L173.667 1.33334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M175 1L175 2L178 2L175 1M123.667 2.33334L124.333 2.66666L123.667 2.33334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M125.667 2.33334L126.333 2.66666L125.667 2.33334M180 2L181 3L180 2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M181.667 2.33334L182.333 2.66666L181.667 2.33334M119 3L120 4L119 3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M120.667 3.33334L121.333 3.66666L120.667 3.33334M185 3L186 4L185 3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M186.667 3.33334L187.333 3.66666L186.667 3.33334M115 4L116 5L115 4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M116 4L117 5L116 4M189 4L190 5L189 4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M190.667 4.33334L191.333 4.66666L190.667 4.33334M111 5L112 6L111 5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M112 5L113 6L112 5M193 5L194 6L193 5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M194 5L195 6L194 5M108 6L109 7L108 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M109 6L110 7L109 6M197 6L198 7L197 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M198 6L199 7L198 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M105 7L106 8L105 7M200 7L201 8L200 7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M201 7L202 8L201 7M102 8L103 9L102 8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M203 8L204 9L203 8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M204 8L205 9L204 8M99 9L100 10L99 9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M100 9L101 10L100 9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M206 9L207 10L206 9M96 10L97 11L96 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M97 10L98 11L97 10M208 10L209 11L208 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M209 10L210 11L209 10M94 11L95 12L94 11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M211 11L212 12L211 11M92 12L93 13L92 12M213 12L214 13L213 12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M214 12L215 13L214 12M89 13L90 14L89 13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M90 13L91 14L90 13M215 13L216 14L215 13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M216 13L217 14L216 13M87 14L88 15L87 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M88 14L89 15L88 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M218 14L219 15L218 14M85 15L86 16L85 15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M86 15L87 16L86 15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M220 15L221 16L220 15M83 16L84 17L83 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M84 16L85 17L84 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M222 16L223 17L222 16M81 17L82 18L81 17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M82 17L83 18L82 17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M224 17L225 18L224 17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M80 18L81 19L80 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M226 18L227 19L226 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M78 19L79 20L78 19M227 19L228 20L227 19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M76 20L77 21L76 20z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M229 20L230 21L229 20z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M74 21L75 22L74 21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M75 21L76 22L75 21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M231 21L232 22L231 21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M73 22L74 23L73 22M232 22L233 23L232 22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M71 23L72 24L71 23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M234 23L235 24L234 23M70 24L71 25L70 24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M236 24L237 25L236 24M386 24L386 25L389 25L386 24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M389.667 24.3333L390.333 24.6667L389.667 24.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M344 101L343 101C339.923 103.662 330.281 108.603 330.346 113.09C330.463 121.236 345.689 127.386 352 129.279C372.938 135.559 401.628 131.647 412.179 110C422.119 89.6057 407.329 76.838 390 69.4213C382.374 66.1576 368.645 60.4989 374.562 50C384.503 32.3617 407.86 41.7706 419 52L420 52L433 40C413.683 12.8071 356.61 20.9862 353.171 57C350.476 85.2234 387.932 78.4508 394.951 98.0039C397.972 106.42 387.726 112.997 381 114.84C366.031 118.944 354.139 111.133 344 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M402.667 24.3333L403.333 24.6667L402.667 24.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M404 24L404 25L407 25L404 24M686 24L686 25L703 25L686 24M68 25L69 26L68 25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M237 25L238 26L237 25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M382 25L383 26L382 25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M383 25L384 26L383 25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M384 25L385 26L384 25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M409 25L410 26L409 25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M410.667 25.3333L411.333 25.6667L410.667 25.3333M450 26L450 27L494 26L537 27C533.298 22.7635 521.373 25 516 25C495.987 25 469.154 20.3384 450 26M550 25L550 26C574.408 26 604.27 21.3502 628 27C624.394 22.8735 613.217 25 608 25L550 25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M603 130L622.536 128.972L643.171 105.603L658 105L692 105L693 130L712 130C709.931 103.786 708.847 77.0654 705.424 51C704.718 45.6236 706.586 29.5295 702.258 26.0278C689.806 15.9536 677.111 35.6116 671.2 43C648.898 70.8763 620.787 99.0812 603 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M703.333 25.6667L703.667 26.3333L703.333 25.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M762 25L762 26L781 27C777.486 22.9784 767.091 25 762 25M827 25L827 26L883 26L913 27C909.204 22.6555 896.527 25 891 25L827 25M926 25L926 26L945 26L926 25M994 25L994 26L1013 26L994 25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M67 26L68 27L67 26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M239 26L240 27L239 26M379 26L380 27L379 26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M380 26L381 27L380 26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M413 26L414 27L413 26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M414 26L415 27L414 26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M446 42L478 42C473.52 72.3323 452.54 99.6909 448 130C452.462 130 461.594 131.75 465.298 128.972C469.796 125.598 471.896 113.243 473.667 108C478.871 92.5985 484.473 77.2699 490.053 62C491.964 56.7698 493.43 47.415 497.649 43.6034C503.347 38.4557 523.501 42 531 42L536 26L477 26L452.419 26.6034L446 42M550 26L524.308 99L514 130L569 130L590.49 128.972L597 114L537 114C539.872 107.552 542.451 89.5583 549.214 86.6034C558.419 82.5814 575.955 86 586 86C589.521 86 595.45 87.1032 598.49 84.9722C602.23 82.3504 603.645 74.1587 605 70L553 70L563.51 43.6034L580 42L622 42L627 26L550 26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M684 26L685 27L684 26M761 26L762 27L761 26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M725 130L777 130L797.501 128.972L804 114L749 114L780 26L761.843 27.6034L750.308 58L725 130M822 42L854 42L824 130C828.462 130 837.594 131.75 841.298 128.972C845.958 125.477 847.784 113.363 849.692 108C855.271 92.3235 860.749 76.5858 866.576 61C868.481 55.9022 869.609 47.4337 873.699 43.6034C879.197 38.4546 899.646 42 907 42L912 26L853 26L828.419 26.6034L822 42M926 26C917.86 61.1682 895.341 94.3403 890 130L907.298 128.972L912.656 117L923 86L973 86L958 130L975.298 128.972L985.808 102L1013 26L994 26L983.667 56L977.775 67.9722L964 69L930 69L945 26L926 26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M65 27L66 28L65 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M240 27L241 28L240 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M376 27L377 28L376 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M377 27L378 28L377 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M416 27L417 28L416 27M450 27L451 28L450 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M549 27L550 28L549 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M683 27L684 28L683 27M826 27L827 28L826 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M925 27L926 28L925 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M944 27L945 28L944 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M993 27L994 28L993 27M1012 27L1013 28L1012 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M64 28L65 29L64 28M241 28L242 29L241 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M374 28L375 29L374 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M418 28L419 29L418 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M419 28L420 29L419 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M535 28L536 29L535 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M549 28L550 29L549 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M626 28L627 29L626 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M682 28L683 29L682 28M760 28L761 29L760 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M779 28L780 29L779 28M911 28L912 29L911 28M925 28L926 29L925 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M944 28L945 29L944 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M993 28L994 29L993 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M243 29L244 30L243 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M372 29L373 30L372 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M421 29L422 30L421 29M449 29L450 30L449 29M626 29L627 30L626 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M760 29L761 30L760 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M825 29L826 30L825 29M911 29L912 30L911 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M1011 29L1012 30L1011 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M61 30L62 31L61 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M244 30L245 31L244 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M370 30L371 31L370 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M422 30L423 31L422 30M449 30L450 31L449 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M548 30L549 31L548 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M825 30L826 31L825 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M924 30L925 31L924 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M943 30L944 31L943 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M992 30L993 31L992 30M1011 30L1012 31L1011 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M60 31L61 32L60 31M245 31L246 32L245 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M368 31L369 32L368 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M369 31L370 32L369 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M424 31L425 32L424 31M534 31L535 32L534 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M625 31L626 32L625 31M680 31L681 32L680 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M704 31L704 36L705 36L704 31M759 31L760 32L759 31M778 31L779 32L778 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M910 31L911 32L910 31M924 31L925 32L924 31M992 31L993 32L992 31M59 32L60 33L59 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M247 32L248 33L247 32M367 32L368 33L367 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M425 32L426 33L425 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M448 32L449 33L448 32M625 32L626 33L625 32M679 32L680 33L679 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M759 32L760 33L759 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M824 32L825 33L824 32M910 32L911 33L910 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M1010 32L1011 33L1010 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M57 33L58 34L57 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M248 33L249 34L248 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M366 33L367 34L366 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M427 33L428 34L427 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M448 33L449 34L448 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M533 33L534 34L533 33M547 33L548 34L547 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M678 33L679 34L678 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M777 33L778 34L777 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M824 33L825 34L824 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M923 33L924 34L923 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M942 33L943 34L942 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M991 33L992 34L991 33M1010 33L1011 34L1010 33M56 34L57 35L56 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M249 34L250 35L249 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M428 34L429 35L428 34M533 34L534 35L533 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M624 34L625 35L624 34M758 34L759 35L758 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M777 34L778 35L777 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M909 34L910 35L909 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M923 34L924 35L923 34M991 34L992 35L991 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M55 35L56 36L55 35M250 35L251 36L250 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M363 35L364 36L363 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M429 35L430 36L429 35M447 35L448 36L447 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M546 35L547 36L546 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M677 35L678 36L677 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M823 35L824 36L823 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M941 35L942 36L941 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M1009 35L1010 36L1009 35M54 36L55 37L54 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M362 36L363 37L362 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M430 36L431 37L430 36M532 36L533 37L532 36M546 36L547 37L546 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M623 36L624 37L623 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M676 36L677 37L676 36M704 36L704 40L705 40L704 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M757 36L758 37L757 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M776 36L777 37L776 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M823 36L824 37L823 36M908 36L909 37L908 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M922 36L923 37L922 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M941 36L942 37L941 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M990 36L991 37L990 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M1009 36L1010 37L1009 36M253 37L254 38L253 37M361 37L362 38L361 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M431 37L432 38L431 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M446 37L447 38L446 37M532 37L533 38L532 37M623 37L624 38L623 37M675 37L676 38L675 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M757 37L758 38L757 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M776 37L777 38L776 37M908 37L909 38L908 37M254 38L255 39L254 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M432 38L433 39L432 38M446 38L447 39L446 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M545 38L546 39L545 38M674 38L675 39L674 38M822 38L823 39L822 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M940 38L941 39L940 38M1008 38L1009 39L1008 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M50 39L51 40L50 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M255 39L256 40L255 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M433 39L434 40L433 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M531 39L532 40L531 39M545 39L546 40L545 39M622 39L623 40L622 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M756 39L757 40L756 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M775 39L776 40L775 39M907 39L908 40L907 39M921 39L922 40L921 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M940 39L941 40L940 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M989 39L990 40L989 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M49 40L50 41L49 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M256 40L257 41L256 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M359 40L360 41L359 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M389 40L389 41L392 41L389 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M392 40L392 41L396 41L392 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M396.667 40.3333L397.333 40.6667L396.667 40.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M432 40L433 41L432 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M445 40L446 41L445 40M531 40L532 41L531 40M622 40L623 41L622 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M673 40L674 41L673 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M756 40L757 41L756 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M775 40L776 41L775 40M907 40L908 41L907 40M48 41L49 42L48 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M143 41L143 42L146 42L143 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M146 41L146 42L160 42L146 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M160 41L160 42L164 42L160 41M257 41L258 42L257 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M358 41L359 42L358 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M385 41L386 42L385 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M386 41L387 42L386 41M400.667 41.3333L401.333 41.6667L400.667 41.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M402 41L403 42L402 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M431 41L432 42L431 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M445 41C449.78 46.4705 470.789 43 478 43L478 42L445 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M544 41L545 42L544 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M672 41L673 42L672 41M821 41C825.78 46.4705 846.789 43 854 43L854 42L821 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M920 41L921 42L920 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M939 41L940 42L939 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M988 41L989 42L988 41M1007 41L1008 42L1007 41M47 42L48 43L47 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M135.667 42.3333L136.333 42.6667L135.667 42.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M137 42L137 43L140 43L137 42M167 42L167 43L170 43L167 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M170 42L171 43L170 42M258 42L259 43L258 42M382 42L383 43L382 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M383 42L384 43L383 42M404 42L405 43L404 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M405 42L406 43L405 42M430 42L431 43L430 42M497 42L497 43L530 43L497 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M530 42L531 43L530 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M544 42L545 43L544 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M563 42L563 43L621 43L602 42L563 42M671 42L672 43L671 42M755 42L756 43L755 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M774 42L775 43L774 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M873 42L874 43L873 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M874 42L874 43L906 43L874 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M906 42L907 43L906 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M920 42L921 43L920 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M939 42L940 43L939 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M988 42L989 43L988 42M46 43L47 44L46 43M130 43L131 44L130 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M131.667 43.3333L132.333 43.6667L131.667 43.3333M173.667 43.3333L174.333 43.6667L173.667 43.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M175.667 43.3333L176.333 43.6667L175.667 43.3333M259 43L260 44L259 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M357 43L358 44L357 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M380 43L381 44L380 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M381 43L382 44L381 43M407 43L408 44L407 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M429 43L430 44L429 43M562 43L563 44L562 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M670 43L671 44L670 43M705 43L705 49L706 49L705 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M755 43L756 44L755 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M1006 43L1007 44L1006 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M45 44L46 45L45 44M126 44L127 45L126 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M127 44L128 45L127 44M178.667 44.3333L179.333 44.6667L178.667 44.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M180 44L181 45L180 44M260 44L261 45L260 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M356 44L357 45L356 44M379 44L380 45L379 44M409 44L410 45L409 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M428 44L429 45L428 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M477 44L478 45L477 44M496 44L497 45L496 44M543 44L544 45L543 44M562 44L563 45L562 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M872 44L873 45L872 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M919 44L920 45L919 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M938 44L939 45L938 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M987 44L988 45L987 44M1006 44L1007 45L1006 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M44 45L45 46L44 45M122 45L123 46L122 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M123 45L124 46L123 45M182 45L183 46L182 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M183 45L184 46L183 45M261 45L262 46L261 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M377 45L378 46L377 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M411 45L412 46L411 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M427 45L428 46L427 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M477 45L478 46L477 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M669 45L670 46L669 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M754 45L755 46L754 45M773 45L774 46L773 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M853 45L854 46L853 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M872 45L873 46L872 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M919 45L920 46L919 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M938 45L939 46L938 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M987 45L988 46L987 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M43 46L44 47L43 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M119 46L120 47L119 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M120 46L121 47L120 46M186 46L187 47L186 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M187 46L188 47L187 46M262 46L263 47L262 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M355 46L356 47L355 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M376 46L377 47L376 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M412 46L413 47L412 46M426 46L427 47L426 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M495 46L496 47L495 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M561 46L562 47L561 46M668 46L669 47L668 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M754 46L755 47L754 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M1005 46L1006 47L1005 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M42 47L43 48L42 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M116 47L117 48L116 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M189 47L190 48L189 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M190 47L191 48L190 47M263 47L264 48L263 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M355 47L356 48L355 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M476 47L477 48L476 47M495 47L496 48L495 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M542 47L543 48L542 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M667 47L668 48L667 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M686 47L687 48L686 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M687 47L688 48L687 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M772 47L773 48L772 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M852 47L853 48L852 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M871 47L872 48L871 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M918 47L919 48L918 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M937 47L938 48L937 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M986 47L987 48L986 47M1005 47L1006 48L1005 47M41 48L42 49L41 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M113 48L114 49L113 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M114 48L115 49L114 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M192 48L193 49L192 48M264 48L265 49L264 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M415 48L416 49L415 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M476 48L477 49L476 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M686 48L656 88L690 88C689.906 76.6784 690.903 58.2033 686 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M687 48L687 53L688 53L687 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M753 48L754 49L753 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M772 48L773 49L772 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M852 48L853 49L852 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M918 48L919 49L918 48M986 48L987 49L986 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M40 49L41 50L40 49M111 49L112 50L111 49M194 49L195 50L194 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M195 49L196 50L195 49M265 49L266 50L265 49M354 49L355 50L354 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M374 49L375 50L374 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M416 49L417 50L416 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M422 49L423 50L422 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M494 49L495 50L494 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M541 49L542 50L541 49M560 49L561 50L560 49M685 49L686 50L685 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M705 49L705 52L706 52L705 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M870 49L871 50L870 49M936 49L937 50L936 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M1004 49L1005 50L1004 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M39 50L40 51L39 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M108 50L109 51L108 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M109 50L110 51L109 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M197 50L198 51L197 50M266 50L267 51L266 50M417 50L418 51L417 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M421 50L422 51L421 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M475 50L476 51L475 50M494 50L495 51L494 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M541 50L542 51L541 50M665 50L666 51L665 50M684 50L685 51L684 50M771 50L772 51L771 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M851 50L852 51L851 50M870 50L871 51L870 50M917 50L918 51L917 50M936 50L937 51L936 50M985 50L986 51L985 50M1004 50L1005 51L1004 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M106 51L107 52L106 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M199 51L200 52L199 51M267 51L268 52L267 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M373 51L374 52L373 51M418 51L419 52L418 51M420 51L421 52L420 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M475 51L476 52L475 51M559 51L560 52L559 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M664 51L665 52L664 51M683 51L684 52L683 51M752 51L753 52L752 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M771 51L772 52L771 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M851 51L852 52L851 51M104 52L105 53L104 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M201 52L202 53L201 52M268 52L269 53L268 52M353 52L354 53L353 52M373 52L374 53L373 52M419 52L420 53L419 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M493 52L494 53L493 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M540 52L541 53L540 52M559 52L560 53L559 52M663 52L664 53L663 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M869 52L870 53L869 52M935 52L936 53L935 52M1003 52L1004 53L1003 52M37 53L38 54L37 53M102 53L103 54L102 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M203 53L204 54L203 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M353.333 53.6667L353.667 54.3333L353.333 53.6667M474 53L475 54L474 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M493 53L494 54L493 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M540 53L541 54L540 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M751 53L752 54L751 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M770 53L771 54L770 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M850 53L851 54L850 53M869 53L870 54L869 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M916 53L917 54L916 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M935 53L936 54L935 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M984 53L985 54L984 53M36 54L37 55L36 54M100 54L101 55L100 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M205 54L206 55L205 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M558 54L559 55L558 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M681 54L682 55L681 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M751 54L752 55L751 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M770 54L771 55L770 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M850 54L851 55L850 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M35 55L36 56L35 55M98 55L99 56L98 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M207 55L208 56L207 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M270 55L271 56L270 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M372 55L373 56L372 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M492 55L493 56L492 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M539 55L540 56L539 55M558 55L559 56L558 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M661 55L662 56L661 55M680 55L681 56L680 55M868 55L869 56L868 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M915 55L916 56L915 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M934 55L935 56L934 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M983 55L984 56L983 55M1002 55L1003 56L1002 55M34 56L35 57L34 56M97 56L98 57L97 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M209 56L210 57L209 56M271 56L272 57L271 56M473 56L474 57L473 56M539 56L540 57L539 56M660 56L661 57L660 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M679 56L680 57L679 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M706 56L706 61L707 61L706 56M750 56L751 57L750 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M769 56L770 57L769 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M849 56L850 57L849 56M868 56L869 57L868 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M915 56L916 57L915 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M934 56L935 57L934 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M983 56L984 57L983 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M95 57L96 58L95 57M210 57L211 58L210 57M272 57L273 58L272 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M557 57L558 58L557 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M659 57L660 58L659 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M688 57L688 61L689 61L688 57M750 57L751 58L750 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M1001 57L1002 58L1001 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M93 58L94 59L93 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M212 58L213 59L212 58M273 58L274 59L273 58M352 58L352 61L353 61L352 58M373 58L374 59L373 58M472 58L473 59L472 58M491 58L492 59L491 58M538 58L539 59L538 58M557 58L558 59L557 58M678 58L679 59L678 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M867 58L868 59L867 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M914 58L915 59L914 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M933 58L934 59L933 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M982 58L983 59L982 58M1001 58L1002 59L1001 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M32 59L33 60L32 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M92 59L93 60L92 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M214 59L215 60L214 59M472 59L473 60L472 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M538 59L539 60L538 59M658 59L659 60L658 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M677 59L678 60L677 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M749 59L750 60L749 59M768 59L769 60L768 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M848 59L849 60L848 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M867 59L868 60L867 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M914 59L915 60L914 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M933 59L934 60L933 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M982 59L983 60L982 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M31 60L32 61L31 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M90 60L91 61L90 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M215 60L216 61L215 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M274 60L275 61L274 60M374 60L375 61L374 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M490 60L491 61L490 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M556 60L557 61L556 60M657 60L658 61L657 60M676 60L677 61L676 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M749 60L750 61L749 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M1000 60L1001 61L1000 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M30 61L31 62L30 61M89 61L90 62L89 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M217 61L218 62L217 61M275 61L276 62L275 61M375 61L376 62L375 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M471 61L472 62L471 61M490 61L491 62L490 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M537 61L538 62L537 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M656 61L657 62L656 61M688 61L688 67L689 67L688 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M706 61L706 64L707 64L706 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M767 61L768 62L767 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M847 61L848 62L847 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M866 61L867 62L866 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M913 61L914 62L913 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M932 61L933 62L932 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M981 61L982 62L981 61M1000 61L1001 62L1000 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M87 62L88 63L87 62M218 62L219 63L218 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M276 62L277 63L276 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M376 62L377 63L376 62M471 62L472 63L471 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M655 62L656 63L655 62M748 62L749 63L748 62M767 62L768 63L767 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M847 62L848 63L847 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M913 62L914 63L913 62M981 62L982 63L981 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M29 63L30 64L29 63M86 63L87 64L86 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M219 63L220 64L219 63M378 63L379 64L378 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M489 63L490 64L489 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M536 63L537 64L536 63M555 63L556 64L555 63M674 63L675 64L674 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M865 63L866 64L865 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M999 63L1000 64L999 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M28 64L29 65L28 64M85 64L86 65L85 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M221 64L222 65L221 64M277 64L278 65L277 64M353 64L354 65L353 64M379 64L380 65L379 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M470 64L471 65L470 64M489 64L490 65L489 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M536 64L537 65L536 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M654 64L655 65L654 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M673 64L674 65L673 64M766 64L767 65L766 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M846 64L847 65L846 64M865 64L866 65L865 64M912 64L913 65L912 64M931 64L932 65L931 64M980 64L981 65L980 64M999 64L1000 65L999 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M83 65L84 66L83 65M222 65L223 66L222 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M278 65L279 66L278 65M353 65L354 66L353 65M381 65L382 66L381 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M470 65L471 66L470 65M554 65L555 66L554 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M653 65L654 66L653 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M672 65L673 66L672 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M747 65L748 66L747 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M766 65L767 66L766 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M846 65L847 66L846 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M980 65L981 66L980 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M27 66L28 67L27 66M82 66L83 67L82 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M223 66L224 67L223 66M383 66L384 67L383 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M488 66L489 67L488 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M535 66L536 67L535 66M554 66L555 67L554 66M652 66L653 67L652 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M864 66L865 67L864 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M930 66L931 67L930 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M998 66L999 67L998 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M26 67L27 68L26 67M81 67L82 68L81 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M279 67L280 68L279 67M354 67L355 68L354 67M385 67L386 68L385 67M469 67L470 68L469 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M488 67L489 68L488 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M535 67L536 68L535 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M651 67L652 68L651 67M671 67L672 68L671 67M746 67L747 68L746 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M765 67L766 68L765 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M845 67L846 68L845 67M864 67L865 68L864 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M911 67L912 68L911 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M930 67L931 68L930 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M979 67L980 68L979 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M80 68L81 69L80 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M226 68L227 69L226 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M280 68L281 69L280 68M354 68L355 69L354 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M387 68L388 69L387 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M388 68L389 69L388 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M553.333 68.6667L553.667 69.3333L553.333 68.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M670 68L671 69L670 68M707 68L707 73L708 73L707 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M746 68L747 69L746 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M765 68L766 69L765 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M845 68L846 69L845 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M25 69L26 70L25 69M227 69L228 70L227 69M355 69L356 70L355 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M390 69L391 70L390 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M487 69L488 70L487 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M534 69L535 70L534 69M554 69L554 70L605 70C591.873 64.4916 568.311 69 554 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M650 69L651 70L650 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M669 69L670 70L669 69M863 69L864 70L863 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M910 69L911 70L910 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M997 69L998 70L997 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M24 70L25 71L24 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M228 70L229 71L228 70M281 70L282 71L281 70M392 70L393 71L392 70M468 70L469 71L468 70M534 70L535 71L534 70M649 70L650 71L649 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M745 70L746 71L745 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M764 70L765 71L764 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M844 70L845 71L844 70M863 70L864 71L863 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M910 70L911 71L910 70M76 71L77 72L76 71M229 71L230 72L229 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M282 71L283 72L282 71M356 71L357 72L356 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M394 71L395 72L394 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M395 71L396 72L395 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M604 71L605 72L604 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M648 71L649 72L648 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M689 71L689 75L690 75L689 71M745 71L746 72L745 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M996 71L997 72L996 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M23 72L24 73L23 72M75 72L76 73L75 72M230 72L231 73L230 72M357 72L358 73L357 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M397 72L398 73L397 72M467 72L468 73L467 72M486 72L487 73L486 72M533 72L534 73L533 72M604 72L605 73L604 72M667 72L668 73L667 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M862 72L863 73L862 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M909 72L910 73L909 72M996 72L997 73L996 72M22 73L23 74L22 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M74 73L75 74L74 73M231 73L232 74L231 73M283 73L284 74L283 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M358 73L359 74L358 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M399 73L400 74L399 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M467 73L468 74L467 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M533 73L534 74L533 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M666 73L667 74L666 73M707 73L707 76L708 76L707 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M744 73L745 74L744 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M763 73L764 74L763 73M843 73L844 74L843 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M862 73L863 74L862 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M909 73L910 74L909 73M73 74L74 75L73 74M232 74L233 75L232 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M284 74L285 75L284 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M359 74L360 75L359 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M401 74L402 75L401 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M485 74L486 75L485 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M603 74L604 75L603 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M646 74L647 75L646 74M665 74L666 75L665 74M744 74L745 75L744 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M995 74L996 75L995 74M21 75L22 76L21 75M72 75L73 76L72 75M233 75L234 76L233 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M360 75L361 76L360 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M402 75L403 76L402 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M466 75L467 76L466 75M485 75L486 76L485 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M532 75L533 76L532 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M603 75L604 76L603 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M645 75L646 76L645 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M689 75L689 81L690 81L689 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M762 75L763 76L762 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M842 75L843 76L842 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M861 75L862 76L861 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M908 75L909 76L908 75M995 75L996 76L995 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M71 76L72 77L71 76M234 76L235 77L234 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M285 76L286 77L285 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M361 76L362 77L361 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M404 76L405 77L404 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M466 76L467 77L466 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M644 76L645 77L644 76M664 76L665 77L664 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M707 76L708 77L707 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M743 76L744 77L743 76M762 76L763 77L762 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M842 76L843 77L842 76M908 76L909 77L908 76M20 77L21 78L20 77M235 77L236 78L235 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M362 77L363 78L362 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M405 77L406 78L405 77M484 77L485 78L484 77M602 77L603 78L602 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M663 77L664 78L663 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M860 77L861 78L860 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M994 77L995 78L994 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M19 78L20 79L19 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M236 78L237 79L236 78M286 78L287 79L286 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M364 78L365 79L364 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M465 78L466 79L465 78M484 78L485 79L484 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M531 78L532 79L531 78M662 78L663 79L662 78M761 78L762 79L761 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M841 78L842 79L841 78M860 78L861 79L860 78M907 78L908 79L907 78M994 78L995 79L994 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M237 79L238 80L237 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M365 79L366 80L365 79M408 79L409 80L408 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M465 79L466 80L465 79M601 79L602 80L601 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M642 79L643 80L642 79M742 79L743 80L742 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M761 79L762 80L761 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M841 79L842 80L841 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M907 79L908 80L907 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M18 80L19 81L18 80M68 80L69 81L68 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M287 80L288 81L287 80M367 80L368 81L367 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M409 80L410 81L409 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M483 80L484 81L483 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M530 80L531 81L530 80M601 80L602 81L601 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M641 80L642 81L641 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M708 80L708 86L709 86L708 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M859 80L860 81L859 80M993 80L994 81L993 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M67 81L68 82L67 81M288 81L289 82L288 81M368 81L369 82L368 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M369 81L370 82L369 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M410 81L411 82L410 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M464 81L465 82L464 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M483 81L484 82L483 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M530 81L531 82L530 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M640 81L641 82L640 81M660 81L661 82L660 81M741 81L742 82L741 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M760 81L761 82L760 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M840 81L841 82L840 81M859 81L860 82L859 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M906 81L907 82L906 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M993 81L994 82L993 81M17 82L18 83L17 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M66 82L67 83L66 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M239 82L240 83L239 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M288 82L289 83L288 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M370 82L371 83L370 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M371 82L372 83L371 82M600 82L601 83L600 82M659 82L660 83L659 82M741 82L742 83L741 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M760 82L761 83L760 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M840 82L841 83L840 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M65 83L66 84L65 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M240 83L241 84L240 83M289 83L290 84L289 83M372 83L373 84L372 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M373 83L374 84L373 83M482 83L483 84L482 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M529 83L530 84L529 83M600 83L601 84L600 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M658 83L659 84L658 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M858 83L859 84L858 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M905 83L906 84L905 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M992 83L993 84L992 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M16 84L17 85L16 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M241 84L242 85L241 84M289 84L290 85L289 84M375 84L376 85L375 84M412 84L413 85L412 84M463 84L464 85L463 84M529 84L530 85L529 84M638 84L639 85L638 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M740 84L741 85L740 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M759 84L760 85L759 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M839 84L840 85L839 84M858 84L859 85L858 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M905 84L906 85L905 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M64 85L65 86L64 85M290 85L291 86L290 85M377 85L378 86L377 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M599 85L600 86L599 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M637 85L638 86L637 85M657 85L658 86L657 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M690 85L690 89L691 89L690 85M740 85L741 86L740 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M759 85L760 86L759 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M991 85L992 86L991 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M15 86L16 87L15 86M63 86L64 87L63 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M290 86L291 87L290 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M379 86L380 87L379 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M380 86L381 87L380 86M413 86L414 87L413 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M462 86L463 87L462 86M481 86L482 87L481 86M528 86L529 87L528 86M636 86L637 87L636 86M656 86L657 87L656 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M708 86L708 89L709 89L708 86M857 86L858 87L857 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M904 86L905 87L904 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M923 86L924 87L923 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M924 86L924 87L972 87C959.586 81.7908 937.526 86 924 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M972.333 86.6667L972.667 87.3333L972.333 86.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M991 86L992 87L991 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M62 87L63 88L62 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M86 87L87 88L86 87M243 87L244 88L243 87M291 87L292 88L291 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M382 87L383 88L382 87M462 87L463 88L462 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M528 87L529 88L528 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M655 87L656 88L655 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M739 87L740 88L739 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M758 87L759 88L758 87M838 87L839 88L838 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M857 87L858 88L857 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M904 87L905 88L904 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M14 88L15 89L14 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M86 88L86 89L89 89L89 88L86 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M87 88L88 89L87 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M89 88L90 89L89 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M244 88L245 89L244 88M291 88L292 89L291 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M384 88L385 89L384 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M414 88L415 89L414 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M480 88L481 89L480 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M546 88L547 89L546 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M635 88L636 89L635 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M655 88L655 89L690 89L655 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M739 88L740 89L739 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M990 88L991 89L990 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M61 89L62 90L61 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M88 89C95.2225 106.085 112.321 122.295 123.651 137C126.919 141.241 136.212 149.403 136.073 155C135.925 161.002 126.389 169.406 122.884 174C111.225 189.281 95.5681 204.795 87 222L240 178.291L319 156L303 149.709L261 137.709L145 104.579L88 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M92 89L93 90L92 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M93 89L94 90L93 89M292 89L293 90L292 89M386 89L387 90L386 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M414 89L415 90L414 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M461 89L462 90L461 89M480 89L481 90L480 89M527 89L528 90L527 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M634 89L635 90L634 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M757 89L758 90L757 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M837 89L838 90L837 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M856 89L857 90L856 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M903 89L904 90L903 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M922 89L923 90L922 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M971 89L972 90L971 89M990 89L991 90L990 89M13 90L14 91L13 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M60 90L61 91L60 90M95 90L96 91L95 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M96 90L97 91L96 90M245 90L246 91L245 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M292 90L293 91L292 90M388 90L389 91L388 90M461 90L462 91L461 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M545 90L546 91L545 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M633 90L634 91L633 90M738 90L739 91L738 90M757 90L758 91L757 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M837 90L838 91L837 90M903 90L904 91L903 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M971 90L972 91L971 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M13 91L14 92L13 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M88 91L89 92L88 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M99 91L100 92L99 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M100 91L101 92L100 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M246 91L247 92L246 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M389 91L390 92L389 91M415 91L415 94L416 94L415 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M479 91L480 92L479 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M545 91L546 92L545 91M632 91L633 92L632 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M855 91L856 92L855 91M921 91L922 92L921 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M989 91L990 92L989 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M12 92L13 93L12 92M59 92L60 93L59 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M89 92L90 93L89 92M102 92L103 93L102 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M103 92L104 93L103 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M293 92L294 93L293 92M391 92L392 93L391 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M460 92L461 93L460 92M479 92L480 93L479 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M526 92L527 93L526 92M756 92L757 93L756 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M836 92L837 93L836 92M855 92L856 93L855 92M902 92L903 93L902 92M921 92L922 93L921 92M970 92L971 93L970 92M989 92L990 93L989 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M12 93L13 94L12 93M58 93L59 94L58 93M90 93L91 94L90 93M106 93L107 94L106 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M107 93L108 94L107 93M247 93L248 94L247 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M392 93L393 94L392 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M460 93L461 94L460 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M544 93L545 94L544 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M631 93L632 94L631 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M709 93L709 98L710 98L709 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M737 93L738 94L737 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M756 93L757 94L756 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M836 93L837 94L836 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M902 93L903 94L902 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M109 94L110 95L109 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M110 94L111 95L110 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M248 94L249 95L248 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M294 94L295 95L294 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M393 94L394 95L393 94M415 94L415 98L416 98L415 94M478 94L479 95L478 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M525 94L526 95L525 94M544 94L545 95L544 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M630 94L631 95L630 94M854 94L855 95L854 94M920 94L921 95L920 94M988 94L989 95L988 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M11 95L12 96L11 95M57 95L58 96L57 95M91 95L92 96L91 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M113 95L114 96L113 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M114 95L115 96L114 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M294 95L295 96L294 95M459 95L460 96L459 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M478 95L479 96L478 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M525 95L526 96L525 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M629 95L630 96L629 95M736 95L737 96L736 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M755 95L756 96L755 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M835 95L836 96L835 95M854 95L855 96L854 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M901 95L902 96L901 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M920 95L921 96L920 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M969 95L970 96L969 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M988 95L989 96L988 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M56 96L57 97L56 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M92 96L93 97L92 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M116 96L117 97L116 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M117 96L118 97L117 96M249 96L250 97L249 96M394 96L395 97L394 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M543 96L544 97L543 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M628 96L629 97L628 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M736 96L737 97L736 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M755 96L756 97L755 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M835 96L836 97L835 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M10 97L11 98L10 97M56 97L57 98L56 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M93 97L94 98L93 97M120 97L121 98L120 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M121 97L122 98L121 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M295 97L296 98L295 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M458 97L459 98L458 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M477 97L478 98L477 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M524 97L525 98L524 97M543 97L544 98L543 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M853 97L854 98L853 97M919 97L920 98L919 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M968 97L969 98L968 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M987 97L988 98L987 97M10 98L11 99L10 98M55 98L56 99L55 98M123 98L124 99L123 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M124 98L125 99L124 98M250 98L251 99L250 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M395 98L396 99L395 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M415 98L415 101L416 101L415 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M458 98L459 99L458 98M524 98L525 99L524 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M627 98L628 99L627 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M709 98L709 101L710 101L709 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M735 98L736 99L735 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M754 98L755 99L754 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M834 98L835 99L834 98M853 98L854 99L853 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M900 98L901 99L900 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M919 98L920 99L919 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M968 98L969 99L968 98M127 99L128 100L127 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M128 99L129 100L128 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M251 99L252 100L251 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M296 99L297 100L296 99M395.333 99.6667L395.667 100.333L395.333 99.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M542 99L543 100L542 99M626 99L627 100L626 99M735 99L736 100L735 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M754 99L755 100L754 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M834 99L835 100L834 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M9 100L10 101L9 100M54 100L55 101L54 100M95 100L96 101L95 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M130 100L131 101L130 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M131 100L132 101L131 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M296 100L297 101L296 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M457 100L458 101L457 100M476 100L477 101L476 100M523 100L524 101L523 100M542 100L543 101L542 100M625 100L626 101L625 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M852 100L853 101L852 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M899 100L900 101L899 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M918 100L919 101L918 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M967 100L968 101L967 100M986 100L987 101L986 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M96 101L97 102L96 101M134 101L135 102L134 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M135 101L136 102L135 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M252 101L253 102L252 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M342 101L343 102L342 101M344 101L345 102L344 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M395.333 101.667L395.667 102.333L395.333 101.667M457 101L458 102L457 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M523 101L524 102L523 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M734 101L735 102L734 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M753 101L754 102L753 101M833 101L834 102L833 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M852 101L853 102L852 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M899 101L900 102L899 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M918 101L919 102L918 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M967 101L968 102L967 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M53 102L54 103L53 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M97 102L98 103L97 102M137 102L138 103L137 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M138 102L139 103L138 102M297 102L298 103L297 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M341 102L342 103L341 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M475 102L476 103L475 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M541 102L542 103L541 102M734 102L735 103L734 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M985 102L986 103L985 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M8 103L9 104L8 103M141 103L142 104L141 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M142 103L143 104L142 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M253 103L254 104L253 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M340 103L341 104L340 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M414 103L415 104L414 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M456 103L457 104L456 103M475 103L476 104L475 103M522 103L523 104L522 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M623 103L624 104L623 103M752 103L753 104L752 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M832 103L833 104L832 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M851 103L852 104L851 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M898 103L899 104L898 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M917 103L918 104L917 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M966 103L967 104L966 103M985 103L986 104L985 103M52 104L53 105L52 104M98 104L99 105L98 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M144 104L145 105L144 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M145 104L146 105L145 104M338 104L339 105L338 104M394 104L395 105L394 104M414 104L415 105L414 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M456 104L457 105L456 104M622 104L623 105L622 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M733 104L734 105L733 104M752 104L753 105L752 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M832 104L833 105L832 104M898 104L899 105L898 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M966 104L967 105L966 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M99 105L100 106L99 105M148 105L149 106L148 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M149 105L150 106L149 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M254 105L255 106L254 105M298 105L299 106L298 105M337 105L338 106L337 105M394 105L395 106L394 105M474 105L475 106L474 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M540 105L541 106L540 105M621 105L622 106L621 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M641 105L642 106L641 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M642 105L642 106L691 106C678.348 100.691 655.788 105 642 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M691 105L692 106L691 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M710 105L710 110L711 110L710 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M733 105L734 106L733 105M850 105L851 106L850 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M984 105L985 106L984 105M7 106L8 107L7 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M51 106L52 107L51 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M100 106L101 107L100 106M151 106L152 107L151 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M152 106L153 107L152 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M336 106L337 107L336 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M393 106L394 107L393 106M455 106L456 107L455 106M474 106L475 107L474 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M521 106L522 107L521 106M691 106L692 107L691 106M751 106L752 107L751 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M831 106L832 107L831 106M850 106L851 107L850 106M897 106L898 107L897 106M916 106L917 107L916 106M965 106L966 107L965 106M984 106L985 107L984 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M155 107L156 108L155 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M156 107L157 108L156 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M255 107L256 108L255 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M334 107L335 108L334 107M350 107L351 108L350 107M413 107L414 108L413 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M455 107L456 108L455 107M539 107L540 108L539 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M691 107L691 114L692 114L691 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M732 107L733 108L732 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M751 107L752 108L751 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M831 107L832 108L831 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M897 107L898 108L897 107M965 107L966 108L965 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M50 108L51 109L50 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M101 108L102 109L101 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M158 108L159 109L158 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M159 108L160 109L159 108M255 108L256 109L255 108M299 108L300 109L299 108M333 108L334 109L333 108M351 108L352 109L351 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M392 108L393 109L392 108M473 108L474 109L473 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M520 108L521 109L520 108M539 108L540 109L539 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M619 108L620 109L619 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M639 108L640 109L639 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M849 108L850 109L849 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M915 108L916 109L915 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M983 108L984 109L983 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M6 109L7 110L6 109M102 109L103 110L102 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M162 109L163 110L162 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M163 109L164 110L163 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M256 109L257 110L256 109M299 109L300 110L299 109M332 109L333 110L332 109M352 109L353 110L352 109M391 109L392 110L391 109M412 109L413 110L412 109M454 109L455 110L454 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M473 109L474 110L473 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M520 109L521 110L520 109M618 109L619 110L618 109M638 109L639 110L638 109M750 109L751 110L750 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M830 109L831 110L830 109M849 109L850 110L849 109M896 109L897 110L896 109M915 109L916 110L915 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M964 109L965 110L964 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M983 109L984 110L983 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M6 110L7 111L6 110M49 110L50 111L49 110M103 110L104 111L103 110M165 110L166 111L165 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M166 110L167 111L166 110M256 110L257 111L256 110M354 110L355 111L354 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M390 110L391 111L390 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M412 110L413 111L412 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M538 110L539 111L538 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M617 110L618 111L617 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M637 110L638 111L637 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M710 110L710 113L711 113L710 110M731 110L732 111L731 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M750 110L751 111L750 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M830 110L831 111L830 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M49 111L50 112L49 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M169 111L170 112L169 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M170 111L171 112L170 111M300 111L301 112L300 111M329 111L330 112L329 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M355 111L356 112L355 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M356 111L357 112L356 111M388 111L389 112L388 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M411 111L412 112L411 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M453 111L454 112L453 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M472 111L473 112L472 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M519 111L520 112L519 111M538 111L539 112L538 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M848 111L849 112L848 111M914 111L915 112L914 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M963 111L964 112L963 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M982 111L983 112L982 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M5 112L6 113L5 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M172 112L173 113L172 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M173 112L174 113L173 112M258 112L259 113L258 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M259 112L260 113L259 112M300 112L301 113L300 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M328 112L329 113L328 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M357 112L358 113L357 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M358 112L359 113L358 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M387 112L388 113L387 112M453 112L454 113L453 112M519 112L520 113L519 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M616 112L617 113L616 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M636 112L637 113L636 112M730 112L731 113L730 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M749 112L750 113L749 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M829 112L830 113L829 112M848 112L849 113L848 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M895 112L896 113L895 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M914 112L915 113L914 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M963 112L964 113L963 112M5 113L6 114L5 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M48 113L49 114L48 113M105 113L106 114L105 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M176 113L177 114L176 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M177 113L178 114L177 113M261 113L262 114L261 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M262 113L263 114L262 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M329 113L330 114L329 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M360 113L361 114L360 113M385 113L386 114L385 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M410 113L411 114L410 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M537 113L538 114L537 113M615 113L616 114L615 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M635 113L636 114L635 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M710 113L711 114L710 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M730 113L731 114L730 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M749 113L749 114L804 114L786 113L749 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M829 113L830 114L829 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M106 114L107 115L106 114M179 114L180 115L179 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M180 114L181 115L180 114M264 114L265 115L264 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M265 114L266 115L265 114M363 114L364 115L363 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M364 114L365 115L364 114M381 114L382 115L381 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M382 114L383 115L382 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M409 114L410 115L409 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M452 114L453 115L452 114M471 114L472 115L471 114M518 114L519 115L518 114M614 114L615 115L614 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M634 114L635 115L634 114M847 114L848 115L847 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M894 114L895 115L894 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M913 114L914 115L913 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M962 114L963 115L962 114M981 114L982 115L981 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M47 115L48 116L47 115M107 115L108 116L107 115M183 115L184 116L183 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M184 115L185 116L184 115M267 115L268 116L267 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M268 115L269 116L268 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M301 115L302 116L301 115M330 115L331 116L330 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M367 115L368 116L367 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M368.667 115.333L369.333 115.667L368.667 115.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M370 115L370 116L378 116L370 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M378 115L379 116L378 115M452 115L453 116L452 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M518 115L519 116L518 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M596 115L597 116L596 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M613 115L614 116L613 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M633 115L634 116L633 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M729 115L730 116L729 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M803 115L804 116L803 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M828 115L829 116L828 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M847 115L848 116L847 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M894 115L895 116L894 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M913 115L914 116L913 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M962 115L963 116L962 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M4 116L5 117L4 116M47 116L48 117L47 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M186 116L187 117L186 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M187 116L188 117L187 116M270 116L271 117L270 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M271 116L272 117L271 116M301 116L302 117L301 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M331 116L332 117L331 116M408 116L409 117L408 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M470 116L471 117L470 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M729 116L730 117L729 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M803 116L804 117L803 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M980 116L981 117L980 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M4 117L5 118L4 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M108 117L109 118L108 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M190 117L191 118L190 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M191 117L192 118L191 117M273 117L274 118L273 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M274 117L275 118L274 117M332 117L333 118L332 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M407 117L408 118L407 117M451 117L452 118L451 117M470 117L471 118L470 117M517 117L518 118L517 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M595 117L596 118L595 117M612 117L613 118L612 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M632 117L633 118L632 117M711 117L711 123L712 123L711 117M827 117L828 118L827 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M846 117L847 118L846 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M893 117L894 118L893 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M912 117L913 118L912 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M961 117L962 118L961 117M980 117L981 118L980 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M46 118L47 119L46 118M109 118L110 119L109 118M193 118L194 119L193 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M194 118L195 119L194 118M276 118L277 119L276 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M277 118L278 119L277 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M302.333 118.667L302.667 119.333L302.333 118.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M333 118L334 119L333 118M406 118L407 119L406 118M451 118L452 119L451 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M595 118L596 119L595 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M611 118L612 119L611 118M631 118L632 119L631 118M692 118L692 121L693 121L692 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M728 118L729 119L728 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M802 118L803 119L802 118M827 118L828 119L827 118M893 118L894 119L893 118M961 118L962 119L961 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M46 119L47 120L46 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M110 119L111 120L110 119M197 119L198 120L197 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M198 119L199 120L198 119M279 119L280 120L279 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M280 119L281 120L280 119M334 119L335 120L334 119M405 119L406 120L405 119M469 119L470 120L469 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M610 119L611 120L610 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M630 119L631 120L630 119M728 119L729 120L728 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M802 119L803 120L802 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M845 119L846 120L845 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M979 119L980 120L979 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M3 120L4 121L3 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M200 120L201 121L200 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M201 120L202 121L201 120M282 120L283 121L282 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M283 120L284 121L283 120M302 120L303 121L302 120M335 120L336 121L335 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M404 120L405 121L404 120M450 120L451 121L450 120M469 120L470 121L469 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M516 120L517 121L516 120M594 120L595 121L594 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M609 120L610 121L609 120M826 120L827 121L826 120M845 120L846 121L845 120M892 120L893 121L892 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M911 120L912 121L911 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M960 120L961 121L960 120M979 120L980 121L979 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M3.33333 121.667L3.66667 122.333L3.33333 121.667M45 121L46 122L45 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M111 121L112 122L111 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M204 121L205 122L204 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M205 121L206 122L205 121M285 121L286 122L285 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M286 121L287 122L286 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M336 121L337 122L336 121M403 121L404 122L403 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M450 121L451 122L450 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M594 121L595 122L594 121M629 121L630 122L629 121M692 121L692 128L693 128L692 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M727 121L728 122L727 121M801 121L802 122L801 121M826 121L827 122L826 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M892 121L893 122L892 121M960 121L961 122L960 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M45 122L46 123L45 122M112 122L113 123L112 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M207 122L208 123L207 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M208 122L209 123L208 122M288 122L289 123L288 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M289 122L290 123L289 122M468 122L469 123L468 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M515 122L516 123L515 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M608 122L609 123L608 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M628 122L629 123L628 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M844 122L845 123L844 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M910 122L911 123L910 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M978 122L979 123L978 122M113 123L114 124L113 123M211 123L212 124L211 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M212 123L213 124L212 123M291 123L292 124L291 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M292 123L293 124L292 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M303.333 123.667L303.667 124.333L303.333 123.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M339 123L340 124L339 123M400 123L401 124L400 123M449 123L450 124L449 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M468 123L469 124L468 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M515 123L516 124L515 123M593 123L594 124L593 123M607 123L608 124L607 123M627 123L628 124L627 123M711 123L711 126L712 126L711 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M825 123L826 124L825 123M844 123L845 124L844 123M891 123L892 124L891 123M910 123L911 124L910 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M959 123L960 124L959 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M978 123L979 124L978 123M2.33333 124.667L2.66667 125.333L2.33333 124.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M44.3333 124.667L44.6667 125.333L44.3333 124.667M214 124L215 125L214 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M215 124L216 125L215 124M294 124L295 125L294 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M295 124L296 125L295 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M340 124L341 125L340 124M399 124L400 125L399 124M593 124L594 125L593 124M606 124L607 125L606 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M626 124L627 125L626 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M726 124L727 125L726 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M800 124L801 125L800 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M825 124L826 125L825 124M218 125L219 126L218 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M219 125L220 126L219 125M297 125L298 126L297 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M298 125L299 126L298 125M303 125L304 126L303 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M342 125L343 126L342 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M397 125L398 126L397 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M448 125L449 126L448 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M467 125L468 126L467 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M514 125L515 126L514 125M605 125L606 126L605 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M843 125L844 126L843 125M909 125L910 126L909 125M977 125L978 126L977 125M2.33333 126.667L2.66667 127.333L2.33333 126.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M44 126L45 127L44 126M115 126L116 127L115 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M221 126L222 127L221 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M222 126L223 127L222 126M300 126L301 127L300 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M301 126L302 127L301 126M344 126L345 127L344 126M395 126L396 127L395 126M448 126L449 127L448 126M514 126L515 127L514 126M592 126L593 127L592 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M625 126L626 127L625 126M725 126L726 127L725 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M799 126L800 127L799 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M824 126L825 127L824 126M843 126L844 127L843 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M890 126L891 127L890 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M909 126L910 127L909 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M958 126L959 127L958 126M116 127L117 128L116 127M225 127L226 128L225 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M226 127L227 128L226 127M303 127L304 128L303 127M346 127L347 128L346 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M393 127L394 128L393 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M604 127L605 128L604 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M624 127L625 128L624 127M725 127L726 128L725 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M799 127L800 128L799 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M824 127L825 128L824 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M43.3333 128.667L43.6667 129.333L43.3333 128.667M117 128L118 129L117 128M228 128L229 129L228 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M229 128L230 129L229 128M348 128L349 129L348 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M349 128L350 129L349 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M391 128L392 129L391 128M447 128L448 129L447 128M466 128L467 129L466 128M513 128L514 129L513 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M603 128L604 129L603 128M623 128L624 129L623 128M842 128L843 129L842 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M889 128L890 129L889 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M908 128L909 129L908 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M957 128L958 129L957 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M976 128L977 129L976 128M232 129L233 130L232 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M233 129L234 130L233 129M351 129L352 130L351 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M352 129L353 130L352 129M388 129L389 130L388 129M447 129C450.514 133.022 460.909 131 466 131L466 130L447 129M513 129C516.606 133.127 527.783 131 533 131L591 131L591 130C566.592 130 536.73 134.65 513 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M591 129L592 130L591 129M602 129L603 130L602 129M712 129L713 130L712 129M724.333 129.667L724.667 130.333L724.333 129.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M798 129L773 130L725 130L725 131L774 131L799 130L798 129M823 129C826.514 133.022 836.909 131 842 131L842 130L823 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M842 129L843 130L842 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M889 129C892.514 133.022 902.909 131 908 131L908 130L889 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M908 129L909 130L908 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M957 129C960.514 133.022 970.909 131 976 131L976 130L957 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M1 130L1 133L2 133L1 130M43 130L44 131L43 130M118 130L119 131L118 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M235 130L236 131L235 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M236 130L237 131L236 130M354.667 130.333L355.333 130.667L354.667 130.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M356 130L357 131L356 130M384 130L385 131L384 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M385 130L386 131L385 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M602 130L602 131L622 131L602 130M693 130L693 131L712 131L693 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M798 130L799 131L798 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M119 131L120 132L119 131M239 131L240 132L239 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M240 131L241 132L240 131M359.667 131.333L360.333 131.667L359.667 131.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M361 131L361 132L364 132L361 131M378.667 131.333L379.333 131.667L378.667 131.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M380.667 131.333L381.333 131.667L380.667 131.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M120 132L121 133L120 132M242 132L243 133L242 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M243 132L244 133L243 132M368 132L368 133L375 133L368 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M1.33333 133.667L1.66667 134.333L1.33333 133.667M42 133L43 134L42 133M246 133L247 134L246 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M247 133L248 134L247 133M42 134L42 137L43 137L42 134M121 134L122 135L121 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M249 134L250 135L249 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M250 134L251 135L250 134M122 135L123 136L122 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M253 135L254 136L253 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M254 135L255 136L254 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M123 136L124 137L123 136M256 136L257 137L256 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M257 136L258 137L257 136M0 137L0 142L1 142L0 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M260 137L261 138L260 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M261 137L262 138L261 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M263 138L264 139L263 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M264 138L265 139L264 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M41.3333 139.667L41.6667 140.333L41.3333 139.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M125 139L126 140L125 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M267 139L268 140L267 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M268 139L269 140L268 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M126 140L127 141L126 140M270 140L271 141L270 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M271 140L272 141L271 140M41 141L41 145L42 145L41 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M127 141L128 142L127 141M274 141L275 142L274 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M275 141L276 142L275 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M0 142L0 146L1 146L0 142M277 142L278 143L277 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M278 142L279 143L278 142M128 143L129 144L128 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M281 143L282 144L281 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M282 143L283 144L282 143M129 144L130 145L129 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M284 144L285 145L284 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M285 144L286 145L285 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M130 145L131 146L130 145M288 145L289 146L288 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M289 145L290 146L289 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M291 146L292 147L291 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M292 146L293 147L292 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M295 147L296 148L295 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M296 147L297 148L296 147M132 148L133 149L132 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M298 148L299 149L298 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M299 148L300 149L299 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M40 149L40 161L41 161L40 149M133 149L134 150L133 149M302 149L303 150L302 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M303 149L304 150L303 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M134 150L135 151L134 150M305 150L306 151L305 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M306 150L307 151L306 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M309 151L310 152L309 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M310 151L311 152L310 151M135 152L136 153L135 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M312 152L313 153L312 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M313 152L314 153L313 152M347 154L347 155C385.027 159.806 424.678 157 463 157L663 157L864 157C901.996 157 941.296 159.765 979 155L956 152.996L920 152L793 152L347 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M136 153L137 154L136 153M316 153L317 154L316 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M317 153L318 154L317 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M137.333 154.667L137.667 155.333L137.333 154.667M319.333 154.667L319.667 155.333L319.333 154.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M320.333 154.667L320.667 155.333L320.333 154.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M136 156L137 157L136 156M315.667 156.333L316.333 156.667L315.667 156.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M317 156L318 157L317 156M135 157L136 158L135 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M312 157L313 158L312 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M313 157L314 158L313 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M308.667 158.333L309.333 158.667L308.667 158.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M310 158L311 159L310 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M305 159L306 160L305 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M306 159L307 160L306 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M133 160L134 161L133 160M301.667 160.333L302.333 160.667L301.667 160.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M303 160L304 161L303 160M132 161L133 162L132 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M298 161L299 162L298 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M299 161L300 162L299 161M131 162L132 163L131 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M294.667 162.333L295.333 162.667L294.667 162.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M296 162L297 163L296 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M291 163L292 164L291 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M292 163L293 164L292 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M0 164L0 168L1 168L0 164M130 164L131 165L130 164M288 164L289 165L288 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M289 164L290 165L289 164M41 165L41 169L42 169L41 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M129 165L130 166L129 165M284 165L285 166L284 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M285 165L286 166L285 165M128 166L129 167L128 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M281 166L282 167L281 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M282 166L283 167L282 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M277 167L278 168L277 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M278 167L279 168L278 167M0 168L0 173L1 173L0 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M127 168L128 169L127 168M274 168L275 169L274 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M275 168L276 169L275 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M41.3333 169.667L41.6667 170.333L41.3333 169.667M126 169L127 170L126 169M270 169L271 170L270 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M271 169L272 170L271 169M125 170L126 171L125 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M267 170L268 171L267 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M268 170L269 171L268 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M263 171L264 172L263 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M264 171L265 172L264 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M260 172L261 173L260 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M261 172L262 173L261 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M0 173L0 310L136 310L136 309C83.5881 307.918 35.0776 265.117 13.7809 220C6.68929 204.976 6.34212 187.702 0 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M42 173L42 176L43 176L42 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M123 173L124 174L123 173M256 173L257 174L256 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M257 173L258 174L257 173M122 174L123 175L122 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M253 174L254 175L253 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M254 174L255 175L254 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M1.33333 175.667L1.66667 176.333L1.33333 175.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M121 175L122 176L121 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M249 175L250 176L249 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M250 175L251 176L250 175M510 175L510 176L517 176L510 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M42 176L43 177L42 176M246 176L247 177L246 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M247 176L248 177L247 176M501 176L501 177L504 177L501 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M504.667 176.333L505.333 176.667L504.667 176.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M506 176.425C476.977 180.376 451.78 198.836 441.865 227C427.477 267.869 456.327 302.256 499 296.711C529.822 292.705 555.755 269.097 563.102 239C572.168 201.857 543.98 171.255 506 176.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M521.667 176.333L522.333 176.667L521.667 176.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M523 176L523 177L526 177L523 176M1 177L1 180L2 180L1 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M120 177L121 178L120 177M242 177L243 178L242 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M243 177L244 178L243 177M496.667 177.333L497.333 177.667L496.667 177.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M498 177L499 178L498 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M527 177L528 178L527 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M528 177L529 178L528 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M529 177L530 178L529 177M661 177L661 178L689 178L661 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M119 178L120 179L119 178M239 178L240 179L239 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M240 178L241 179L240 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M352 178L353 179L352 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M311 295L344 295C345.771 287.347 350.273 266.215 357.225 262.028C364.095 257.889 378.124 261.592 386 260.83C410.325 258.476 432.586 243.253 436.561 218C442.241 181.914 406.88 178 380 178C373.564 178 358.876 175.26 353.51 179.028C346.96 183.627 343.558 203.489 340.997 211C331.403 239.13 320.197 266.736 311 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M398 178L398 179L402 179L398 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M402 178L402 179L406 179L402 178M493 178L494 179L493 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M494 178L495 179L494 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M531 178L532 179L531 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M532 178L533 179L532 178M584 178L584 185L585 185L584 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M585 178L582 296C589.361 296 604.176 298.85 610.535 294.972C616.142 291.553 620.338 282.324 624.025 277C634.405 262.01 644.561 242.282 658 230L657 296C664.64 296 679.095 298.791 685.816 294.972C695.705 289.353 703.991 270.336 710.344 261C728.993 233.595 750.877 206.959 767 178C758.233 178 739.889 174.49 732.326 179.028C726.829 182.326 722.828 191.749 719.333 197C709.186 212.249 700.147 232.262 687 245L689 178L661.093 179.028L647.576 197L614 245L618 178L585 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M660 178L661 179L660 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M731 178L732 179L731 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M776 178L735 295L803 295C809.294 295 823.213 297.614 828.501 293.972C834.159 290.075 836.839 274.387 839 268L777 268C777.74 262.991 779.562 254.098 783.51 250.603C786.828 247.666 793.898 249 798 249C808.317 249 828.333 252.908 837.582 248.397C843.144 245.683 846.098 229.621 848 224C830.299 224 809.232 227.103 792 223C794.137 218.202 795.499 208.874 800.225 206.028C803.802 203.873 809.986 205 814 205L846 205C849.836 205 856.235 206.195 859.581 203.972C865.111 200.298 868.292 184.258 870 178L776 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M888 178L889 179L888 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M847 295L880 295C882.14 285.968 885.906 269.478 891.843 262.318C894.703 258.869 904.12 258.72 906.914 262.318C913.128 270.318 911.545 287.857 919.702 293.972C925.954 298.658 946.216 295 954 295L940 256C950.216 252.67 959.97 248.614 967.561 240.714C980.657 227.084 984.851 200.578 968.996 187.329C955.875 176.364 935.013 178 919 178C911.955 178 895.354 174.924 889.51 179.028C883.089 183.536 879.533 203.582 877.003 211C867.41 239.129 856.21 266.745 847 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M940 178L940 179L944 179L940 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M944 178L944 179L947 179L944 178M43 179L44 180L43 179M118 179L119 180L118 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M235 179L236 180L235 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M236 179L237 180L236 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M408 179L409 180L408 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M409.667 179.333L410.333 179.667L409.667 179.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M490 179L491 180L490 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M535 179L536 180L535 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M659 179L660 180L659 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M766 179L767 180L766 179M775 179L776 180L775 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M949 179L950 180L949 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M950 179L951 180L950 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M951.667 179.333L952.333 179.667L951.667 179.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M43.3333 180.667L43.6667 181.333L43.3333 180.667M232 180L233 181L232 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M233 180L234 181L233 180M351 180L352 181L351 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M412 180L413 181L412 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M413 180L414 181L413 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M414 180L415 181L414 180M487 180L488 181L487 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M537 180L538 181L537 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M538 180L539 181L538 180M658 180L659 181L658 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M730 180L731 181L730 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M765 180L766 181L765 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M775 180L776 181L775 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M869 180L870 181L869 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M954 180L955 181L954 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M955.667 180.333L956.333 180.667L955.667 180.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M117 181L118 182L117 181M228 181L229 182L228 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M229 181L230 182L229 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M351 181L352 182L351 181M416 181L417 182L416 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M417 181L418 182L417 181M484 181L485 182L484 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M485 181L486 182L485 181M539 181L540 182L539 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M540 181L541 182L540 181M729 181L730 182L729 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M887 181L888 182L887 181M958 181L959 182L958 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M959 181L960 182L959 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M2.33333 182.667L2.66667 183.333L2.33333 182.667M116 182L117 183L116 182M225 182L226 183L225 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M226 182L227 183L226 182M303 182L304 183L303 182M419 182L420 183L419 182M482 182L483 183L482 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M541 182L542 183L541 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M542 182L543 183L542 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M617 182L617 186L618 186L617 182M657 182L658 183L657 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M764 182L765 183L764 182M774 182L775 183L774 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M868 182L869 183L868 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M961 182L962 183L961 182M44 183L45 184L44 183M115 183L116 184L115 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M221 183L222 184L221 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M222 183L223 184L222 183M300 183L301 184L300 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M301 183L302 184L301 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M350 183L351 184L350 183M421 183L422 184L421 183M480 183L481 184L480 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M543 183L544 184L543 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M656 183L657 184L656 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M688 183L689 184L688 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M728 183L729 184L728 183M763 183L764 184L763 183M774 183L775 184L774 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M868 183L869 184L868 183M886 183L887 184L886 183M963 183L964 184L963 183M2.33333 184.667L2.66667 185.333L2.33333 184.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M44.3333 184.667L44.6667 185.333L44.3333 184.667M218 184L219 185L218 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M219 184L220 185L219 184M297 184L298 185L297 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M298 184L299 185L298 184M303 184L304 185L303 184M350 184L351 185L350 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M423 184L424 185L423 184M478 184L479 185L478 184M545 184L546 185L545 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M688 184L688 195L689 195L688 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M727 184L728 185L727 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M886 184L887 185L886 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M965 184L966 185L965 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M214 185L215 186L214 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M215 185L216 186L215 185M294 185L295 186L294 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M295 185L296 186L295 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M303.333 185.667L303.667 186.333L303.333 185.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M424 185L425 186L424 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M476 185L477 186L476 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M546 185L547 186L546 185M655 185L656 186L655 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M762 185L763 186L762 185M773 185L774 186L773 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M867 185L868 186L867 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M966 185L967 186L966 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M113 186L114 187L113 186M211 186L212 187L211 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M212 186L213 187L212 186M291 186L292 187L291 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M292 186L293 187L292 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M349 186L350 187L349 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M475 186L476 187L475 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M617 186L617 195L618 195L617 186M654 186L655 187L654 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M726 186L727 187L726 186M761 186L762 187L761 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M867 186L868 187L867 186M885 186L886 187L885 186M968 186L969 187L968 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M3.33333 187.667L3.66667 188.333L3.33333 187.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M45 187L46 188L45 187M112 187L113 188L112 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M207 187L208 188L207 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M208 187L209 188L208 187M288 187L289 188L288 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M289 187L290 188L289 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M349 187L350 188L349 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M427 187L428 188L427 187M473 187L474 188L473 187M549 187L550 188L549 187M725 187L726 188L725 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M885 187L886 188L885 187M969 187L970 188L969 187M45 188L46 189L45 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M111 188L112 189L111 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M204 188L205 189L204 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M205 188L206 189L205 188M285 188L286 189L285 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M286 188L287 189L286 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M428 188L429 189L428 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M472 188L473 189L472 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M550 188L551 189L550 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M653 188L654 189L653 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M760 188L761 189L760 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M772 188L773 189L772 188M866 188L867 189L866 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M970 188L971 189L970 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M3 189L4 190L3 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M200 189L201 190L200 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M201 189L202 190L201 189M282 189L283 190L282 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M283 189L284 190L283 189M302 189L303 190L302 189M348 189L349 190L348 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M429 189L430 190L429 189M470 189L471 190L470 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M551 189L552 190L551 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M652 189L653 190L652 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M724 189L725 190L724 189M759 189L760 190L759 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M866 189L867 190L866 189M884 189L885 190L884 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M971 189L972 190L971 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M46 190L47 191L46 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M110 190L111 191L110 190M197 190L198 191L197 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M198 190L199 191L198 190M279 190L280 191L279 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M280 190L281 191L280 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M302.333 190.667L302.667 191.333L302.333 190.667M430 190L431 191L430 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M469 190L470 191L469 190M552 190L553 191L552 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M723 190L724 191L723 190M771 190L772 191L771 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M884 190L885 191L884 190M972 190L973 191L972 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M46 191L47 192L46 191M109 191L110 192L109 191M193 191L194 192L193 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M194 191L195 192L194 191M276 191L277 192L276 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M277 191L278 192L277 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M431 191L432 192L431 191M467 191L468 192L467 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M553 191L554 192L553 191M651 191L652 192L651 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M758 191L759 192L758 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M771 191L772 192L771 191M865 191L866 192L865 191M973 191L974 192L973 191M4 192L5 193L4 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M108 192L109 193L108 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M190 192L191 193L190 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M191 192L192 193L191 192M273 192L274 193L273 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M274 192L275 193L274 192M347 192L348 193L347 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M466 192L467 193L466 192M554 192L555 193L554 192M650 192L651 193L650 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M722 192L723 193L722 192M757 192L758 193L757 192M883 192L884 193L883 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M974 192L975 193L974 192M4 193L5 194L4 193M47 193L48 194L47 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M186 193L187 194L186 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M187 193L188 194L187 193M270 193L271 194L270 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M271 193L272 194L271 193M301 193L302 194L301 193M432 193L433 194L432 193M465 193L466 194L465 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M555 193L556 194L555 193M721 193L722 194L721 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M756 193L757 194L756 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M770 193L771 194L770 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M864 193L865 194L864 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M47 194L48 195L47 194M107 194L108 195L107 194M183 194L184 195L183 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M184 194L185 195L184 194M267 194L268 195L267 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M268 194L269 195L268 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M301 194L302 195L301 194M346 194L347 195L346 194M433 194L434 195L433 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M464 194L465 195L464 194M649 194L650 195L649 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M770 194L771 195L770 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M864 194L865 195L864 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M975 194L976 195L975 194M106 195L107 196L106 195M179 195L180 196L179 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M180 195L181 196L180 195M264 195L265 196L264 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M265 195L266 196L265 195M346 195L347 196L346 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M463 195L464 196L463 195M556 195L557 196L556 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M648 195L649 196L648 195M688 195L688 218L689 218L688 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M720 195L721 196L720 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M755 195L756 196L755 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M882 195L883 196L882 195M5 196L6 197L5 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M48 196L49 197L48 196M105 196L106 197L105 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M176 196L177 197L176 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M177 196L178 197L177 196M261 196L262 197L261 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M262 196L263 197L262 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M434 196L435 197L434 196M557 196L558 197L557 196M583 196L583 216L584 216L583 196M719 196L720 197L719 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M754 196L755 197L754 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M769 196L770 197L769 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M863 196L864 197L863 196M976 196L977 197L976 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M5 197L6 198L5 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M172 197L173 198L172 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M173 197L174 198L173 197M258 197L259 198L258 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M259 197L260 198L259 197M300 197L301 198L300 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M345 197L346 198L345 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M647 197L648 198L647 197M769 197L770 198L769 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M863 197L864 198L863 197M881 197L882 198L881 197M49 198L50 199L49 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M169 198L170 199L169 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M170 198L171 199L170 198M300 198L301 199L300 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M345 198L346 199L345 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M435 198L436 199L435 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M558 198L559 199L558 198M646 198L647 199L646 198M718 198L719 199L718 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M753 198L754 199L753 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M881 198L882 199L881 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M977 198L978 199L977 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M6 199L7 200L6 199M49 199L50 200L49 199M103 199L104 200L103 199M165 199L166 200L165 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M166 199L167 200L166 199M256 199L257 200L256 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M435 199L436 200L435 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M559 199L560 200L559 199M645 199L646 200L645 199M717 199L718 200L717 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M752 199L753 200L752 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M768 199L769 200L768 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M862 199L863 200L862 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M977 199L978 200L977 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M6 200L7 201L6 200M102 200L103 201L102 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M162 200L163 201L162 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M163 200L164 201L163 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M256 200L257 201L256 200M299 200L300 201L299 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M344 200L345 201L344 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M616 200L616 204L617 204L616 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M862 200L863 201L862 200M880 200L881 201L880 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M50 201L51 202L50 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M101 201L102 202L101 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M158 201L159 202L158 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M159 201L160 202L159 201M255 201L256 202L255 201M299 201L300 202L299 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M344 201L345 202L344 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M436 201L437 202L436 201M560 201L561 202L560 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M644 201L645 202L644 201M716 201L717 202L716 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M751 201L752 202L751 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M880 201L881 202L880 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M978 201L979 202L978 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M155 202L156 203L155 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M156 202L157 203L156 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M255 202L256 203L255 202M436 202L437 203L436 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M456 202L457 203L456 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M643 202L644 203L643 202M715 202L716 203L715 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M750 202L751 203L750 202M767 202L768 203L767 202M861 202L862 203L861 202M978 202L979 203L978 202M7 203L8 204L7 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M51 203L52 204L51 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M100 203L101 204L100 203M151 203L152 204L151 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M152 203L153 204L152 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M343 203L344 204L343 203M455 203L456 204L455 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M561 203L562 204L561 203M879 203L880 204L879 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M978 203L979 204L978 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M99 204L100 205L99 204M148 204L149 205L148 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M149 204L150 205L149 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M254 204L255 205L254 204M298 204L299 205L298 204M454 204L455 205L454 204M561 204L562 205L561 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M616 204L616 213L617 213L616 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M642 204L643 205L642 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M714 204L715 205L714 204M749 204L750 205L749 204M766 204L767 205L766 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M860 204L861 205L860 204M879 204L880 205L879 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M52 205L53 206L52 205M98 205L99 206L98 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M144 205L145 206L144 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M145 205L146 206L145 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M375 205L376 206L375 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M376 205L376 206L390 206L376 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M390.667 205.333L391.333 205.667L390.667 205.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M437 205L437 216L438 216L437 205M453 205L454 206L453 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M502 205L503 206L502 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M503 205L503 206L513 206L503 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M513.667 205.333L514.333 205.667L513.667 205.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M641 205L642 206L641 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M748 205L749 206L748 205M766 205L767 206L766 205M799 205L799 206L860 206L840 205L799 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M860 205L861 206L860 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M8 206L9 207L8 206M141 206L142 207L141 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M142 206L143 207L142 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M253 206L254 207L253 206M342 206L343 207L342 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M375 206L365 236C374.961 236 386.132 237.12 394.96 231.521C402.83 226.529 407.271 212.64 396.985 207.573C390.729 204.491 381.784 206 375 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M394 206L395 207L394 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M395 206L396 207L395 206M498 206L499 207L498 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M499 206L500 207L499 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M500 206.529C483.326 210.356 471.719 228.541 471.259 245C470.794 261.688 485.691 270.597 501 267.331C515.81 264.171 527.764 250.775 530.532 236C534.329 215.739 520.365 201.856 500 206.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M516 206L517 207L516 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M517 206L518 207L517 206M562 206L563 207L562 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M713 206L714 207L713 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M798 206L799 207L798 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M878 206L879 207L878 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M911 206L911 207L934 207L911 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M934.667 206.333L935.333 206.667L934.667 206.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M979 206L979 216L980 216L979 206M53 207L54 208L53 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M97 207L98 208L97 207M137 207L138 208L137 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M138 207L139 208L138 207M297 207L298 208L297 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M374 207L375 208L374 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M397 207L398 208L397 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M452 207L453 208L452 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M496 207L497 208L496 207M519 207L520 208L519 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M640 207L641 208L640 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M712 207L713 208L712 207M747 207L748 208L747 207M765 207L766 208L765 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M911 207L902 234C912.577 234 925.149 235.766 935 231.08C942.672 227.43 950.523 213.951 939.956 208.573C932.228 204.639 919.475 207 911 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M937 207L938 208L937 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M938 207L939 208L938 207M9 208L10 209L9 208M96 208L97 209L96 208M134 208L135 209L134 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M135 208L136 209L135 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M252 208L253 209L252 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M341 208L342 209L341 208M374 208L375 209L374 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M399 208L400 209L399 208M451 208L452 209L451 208M493 208L494 209L493 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M494 208L495 209L494 208M521 208L522 209L521 208M639 208L640 209L639 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M746 208L747 209L746 208M765 208L766 209L765 208M797 208L798 209L797 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M877 208L878 209L877 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M910 208L911 209L910 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M940 208L941 209L940 208M9 209L10 210L9 209M54 209L55 210L54 209M95 209L96 210L95 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M130 209L131 210L130 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M131 209L132 210L131 209M251 209L252 210L251 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M296 209L297 210L296 209M341 209L342 210L341 209M400 209L401 210L400 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M450 209L451 210L450 209M492 209L493 210L492 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M523 209L524 210L523 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M563 209L564 210L563 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M711 209L712 210L711 209M745 209L746 210L745 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M797 209L798 210L797 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M877 209L878 210L877 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M910 209L911 210L910 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M127 210L128 211L127 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M128 210L129 211L128 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M251 210L252 211L251 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M296 210L297 211L296 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M373 210L374 211L373 210M401 210L402 211L401 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M490 210L491 211L490 210M524 210L525 211L524 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M563 210L564 211L563 210M638 210L639 211L638 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M710 210L711 211L710 210M764 210L765 211L764 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M10 211L11 212L10 211M55 211L56 212L55 211M123 211L124 212L123 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M124 211L125 212L124 211M250 211L251 212L250 211M340 211L341 212L340 211M373 211L374 212L373 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M449 211L450 212L449 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M488 211L489 212L488 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M525 211L526 212L525 211M637 211L638 212L637 211M744 211L745 212L744 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M764 211L765 212L764 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M796 211L797 212L796 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M876 211L877 212L876 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M909 211L910 212L909 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M10 212L11 213L10 212M56 212L57 213L56 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M93 212L94 213L93 212M120 212L121 213L120 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M121 212L122 213L121 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M295 212L296 213L295 212M340 212L341 213L340 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M402 212L403 213L402 212M448 212L449 213L448 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M487 212L488 213L487 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M526 212L527 213L526 212M564.333 212.667L564.667 213.333L564.333 212.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M709 212L710 213L709 212M743 212L744 213L743 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M796 212L797 213L796 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M876 212L877 213L876 212M944 212L945 213L944 212M56 213L57 214L56 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M92 213L93 214L92 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M116 213L117 214L116 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M117 213L118 214L117 213M249 213L250 214L249 213M295 213L296 214L295 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M372 213L373 214L372 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M486 213L487 214L486 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M527 213L528 214L527 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M636 213L637 214L636 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M708 213L709 214L708 213M763 213L764 214L763 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M908 213L909 214L908 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M11 214L12 215L11 214M57 214L58 215L57 214M91 214L92 215L91 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M113 214L114 215L113 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M114 214L115 215L114 214M339 214L340 215L339 214M372 214L373 215L372 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M403 214L404 215L403 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M447 214L448 215L447 214M485 214L486 215L485 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M564.333 214.667L564.667 215.333L564.333 214.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M635 214L636 215L635 214M742 214L743 215L742 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M795 214L796 215L795 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M875 214L876 215L875 214M908 214L909 215L908 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M945 214L946 215L945 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M109 215L110 216L109 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M110 215L111 216L110 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M248 215L249 216L248 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M294 215L295 216L294 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M339 215L340 216L339 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M403 215L404 216L403 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M528 215L529 216L528 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M707 215L708 216L707 215M741 215L742 216L741 215M875 215L876 216L875 215M945 215L946 216L945 215M12 216L13 217L12 216M58 216L59 217L58 216M90 216L91 217L90 216M106 216L107 217L106 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M107 216L108 217L107 216M247 216L248 217L247 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M371 216L372 217L371 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M403.333 216.667L403.667 217.333L403.333 216.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M446 216L447 217L446 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M483 216L484 217L483 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M529 216L530 217L529 216M583 216L583 227L584 227L583 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M634 216L635 217L634 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M706 216L707 217L706 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M762 216L763 217L762 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M794 216L795 217L794 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M907 216L908 217L907 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M945 216L946 217L945 216M12 217L13 218L12 217M59 217L60 218L59 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M89 217L90 218L89 217M102 217L103 218L102 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M103 217L104 218L103 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M293 217L294 218L293 217M338 217L339 218L338 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M482 217L483 218L482 217M529 217L530 218L529 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M633 217L634 218L633 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M740 217L741 218L740 217M794 217L795 218L794 217M874 217L875 218L874 217M907 217L908 218L907 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M945.333 217.667L945.667 218.333L945.333 217.667M13 218L14 219L13 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M88 218L89 219L88 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M99 218L100 219L99 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M100 218L101 219L100 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M246 218L247 219L246 218M403.333 218.667L403.667 219.333L403.333 218.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M436 218L437 219L436 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M445 218L446 219L445 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M481 218L482 219L481 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M615 218L615 223L616 223L615 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M632 218L633 219L632 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M705 218L706 219L705 218M739 218L740 219L739 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M761 218L762 219L761 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M874 218L875 219L874 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M978.333 218.667L978.667 219.333L978.333 218.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M13 219L14 220L13 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M60 219L61 220L60 219M95 219L96 220L95 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M96 219L97 220L96 219M245 219L246 220L245 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M292 219L293 220L292 219M370 219L371 220L370 219M436 219L437 220L436 219M480 219L481 220L480 219M530 219L531 220L530 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M565 219L565 228L566 228L565 219M704 219L705 220L704 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M761 219L762 220L761 219M793 219L794 220L793 219M906 219L907 220L906 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M61 220L62 221L61 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M87 220L88 221L87 220M92 220L93 221L92 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M93 220L94 221L93 220M292 220L293 221L292 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M337 220L338 221L337 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M436.333 220.667L436.667 221.333L436.333 220.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M444 220L445 221L444 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M530 220L531 221L530 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M631 220L632 221L631 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M738 220L739 221L738 220M793 220L794 221L793 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M873 220L874 221L873 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M906 220L907 221L906 220M978 220L979 221L978 220M14 221L15 222L14 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M86 221L87 222L86 221M88 221L89 222L88 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M89 221L90 222L89 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M244 221L245 222L244 221M291 221L292 222L291 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M369 221L370 222L369 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M479 221L480 222L479 221M630 221L631 222L630 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M703 221L704 222L703 221M737 221L738 222L737 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M760 221L761 222L760 221M944 221L945 222L944 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M62 222L63 223L62 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M86 222L87 223L86 222M243 222L244 223L243 222M291 222L292 223L291 222M336 222L337 223L336 222M369 222L370 223L369 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M402 222L403 223L402 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M443 222L444 223L443 222M478 222L479 223L478 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M531.333 222.667L531.667 223.333L531.333 222.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M702 222L703 223L702 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M760 222L761 223L760 222M792 222L793 223L792 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M872 222L873 223L872 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M905 222L906 223L905 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M944 222L945 223L944 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M15 223L16 224L15 223M63 223L64 224L63 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M290 223L291 224L290 223M336 223L337 224L336 223M435 223L436 224L435 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M615 223L615 231L616 231L615 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M629 223L630 224L629 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M736 223L737 224L736 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M793 223L793 224L848 224L830 223L793 223M872 223L873 224L872 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M943 223L944 224L943 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M977 223L978 224L977 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M64 224L65 225L64 224M290 224L291 225L290 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M368 224L369 225L368 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M401 224L402 225L401 224M435 224L436 225L435 224M442 224L443 225L442 224M477 224L478 225L477 224M531 224L531 233L532 233L531 224M628 224L629 225L628 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M701 224L702 225L701 224M735 224L736 225L735 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M759 224L760 225L759 224M977 224L978 225L977 224M16 225L17 226L16 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M241 225L242 226L241 225M289 225L290 226L289 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M335 225L336 226L335 225M368 225L369 226L368 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M442 225L443 226L442 225M476 225L477 226L476 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M700 225L701 226L700 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M734 225L735 226L734 225M759 225L760 226L759 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M847 225L848 226L847 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M871 225L872 226L871 225M904 225L905 226L904 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M942 225L943 226L942 225M65 226L66 227L65 226M240 226L241 227L240 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M289 226L290 227L289 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M335 226L336 227L335 226M400 226L401 227L400 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M434 226L435 227L434 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M627 226L628 227L627 226M871 226L872 227L871 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M941 226L942 227L941 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M976 226L977 227L976 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M17 227L18 228L17 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M66 227L67 228L66 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M239 227L240 228L239 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M288 227L289 228L288 227M367 227L368 228L367 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M399 227L400 228L399 227M434 227L435 228L434 227M441 227L442 228L441 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M475 227L476 228L475 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M626 227L627 228L626 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M699 227L700 228L699 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M733 227L734 228L733 227M758 227L759 228L758 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M903 227L904 228L903 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M940 227L941 228L940 227M976 227L977 228L976 227M67 228L68 229L67 228M288 228L289 229L288 228M334 228L335 229L334 228M367 228L368 229L367 228M698 228L699 229L698 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M732 228L733 229L732 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M846 228L847 229L846 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M870 228L871 229L870 228M903 228L904 229L903 228M939 228L940 229L939 228M18 229L19 230L18 229M68 229L69 230L68 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M287 229L288 230L287 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M334 229L335 230L334 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M433 229L434 230L433 229M474 229L475 230L474 229M625 229L626 230L625 229M870 229L871 230L870 229M938 229L939 230L938 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M975 229L976 230L975 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M237 230L238 231L237 230M366 230L367 231L366 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M396 230L397 231L396 230M433 230L434 231L433 230M440 230L441 231L440 230M474 230L475 231L474 230M624 230L625 231L624 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M656 230L657 245L658 245L656 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M687 230L688 231L687 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M697 230L698 231L697 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M731 230L732 231L731 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M757 230L758 231L757 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M845 230L846 231L845 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M902 230L903 231L902 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M936 230L937 231L936 230M19 231L20 232L19 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M236 231L237 232L236 231M286 231L287 232L286 231M333 231L334 232L333 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M366 231L367 232L366 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M395 231L396 232L395 231M432 231L433 232L432 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M440 231L441 232L440 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M564.333 231.667L564.667 232.333L564.333 231.667M687 231L687 242L688 242L687 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M696 231L697 232L696 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M730 231L731 232L730 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M845 231L846 232L845 231M869 231L870 232L869 231M902 231L903 232L902 231M934 231L935 232L934 231M974 231L975 232L974 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M20 232L21 233L20 232M235 232L236 233L235 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M393 232L394 233L393 232M432 232L433 233L432 232M473 232L474 233L473 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M623 232L624 233L623 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M655 232L656 233L655 232M756 232L757 233L756 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M869 232L870 233L869 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M931 232L932 233L931 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M932 232L933 233L932 232M71 233L72 234L71 233M234 233L235 234L234 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M285 233L286 234L285 233M332 233L333 234L332 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M365 233L366 234L365 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M391 233L392 234L391 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M431 233L432 234L431 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M439 233L440 234L439 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M531 233L532 234L531 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M564.333 233.667L564.667 234.333L564.333 233.667M622 233L623 234L622 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M654 233L655 234L654 233M695 233L696 234L695 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M729 233L730 234L729 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M756 233L757 234L756 233M844 233L845 234L844 233M901 233L902 234L901 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M926.667 233.333L927.333 233.667L926.667 233.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M928 233L929 234L928 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M929 233L930 234L929 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M973 233L974 234L973 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M21 234L22 235L21 234M72 234L73 235L72 234M233 234L234 235L233 234M332 234L333 235L332 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M388 234L389 235L388 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M389 234L390 235L389 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M431 234L432 235L431 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M439 234L440 235L439 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M472 234L473 235L472 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M694 234L695 235L694 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M728 234L729 235L728 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M844 234L845 235L844 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M868 234L869 235L868 234M902 234L902 235L923 235L902 234M972 234L973 235L972 234M73 235L74 236L73 235M232 235L233 236L232 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M284 235L285 236L284 235M383.667 235.333L384.333 235.667L383.667 235.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M385 235L386 236L385 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M386 235L387 236L386 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M430 235L431 236L430 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M439 235L440 236L439 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M472.333 235.667L472.667 236.333L472.333 235.667M653 235L654 236L653 235M755 235L756 236L755 235M22 236L23 237L22 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M74 236L75 237L74 236M231 236L232 237L231 236M283 236L284 237L283 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M331 236L332 237L331 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M365 236L365 237L380 237L365 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M530 236L531 237L530 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M614 236L614 241L615 241L614 236M620 236L621 237L620 236M652 236L653 237L652 236M693 236L694 237L693 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M727 236L728 237L727 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M755 236L756 237L755 236M843 236L844 237L843 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M867 236L868 237L867 236M971 236L972 237L971 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M23 237L24 238L23 237M75 237L76 238L75 237M230 237L231 238L230 237M331 237L332 238L331 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M429 237L430 238L429 237M438.333 237.667L438.667 238.333L438.333 237.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M530 237L531 238L530 237M563 237L564 238L563 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M619 237L620 238L619 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M651 237L652 238L651 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M692 237L693 238L692 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M726 237L727 238L726 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M843 237L844 238L843 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M867 237L868 238L867 237M970 237L971 238L970 237M76 238L77 239L76 238M229 238L230 239L229 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M282 238L283 239L282 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M428 238L429 239L428 238M471.333 238.667L471.667 239.333L471.333 238.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M563.333 238.667L563.667 239.333L563.333 238.667M582 238L582 258L583 258L582 238M754 238L755 239L754 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M969 238L970 239L969 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M24 239L25 240L24 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M228 239L229 240L228 239M281 239L282 240L281 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M330 239L331 240L330 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M427 239L428 240L427 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M438.333 239.667L438.667 240.333L438.333 239.667M618 239L619 240L618 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M650 239L651 240L650 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M691 239L692 240L691 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M725 239L726 240L725 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M754 239L755 240L754 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M842 239L843 240L842 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M866 239L867 240L866 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M968 239L969 240L968 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M25 240L26 241L25 240M227 240L228 241L227 240M330 240L331 241L330 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M471 240L471 243L472 243L471 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M529 240L530 241L529 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M617 240L618 241L617 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M649 240L650 241L649 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M690 240L691 241L690 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M724 240L725 241L724 240M866 240L867 241L866 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M80 241L81 242L80 241M280 241L281 242L280 241M426 241L427 242L426 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M562 241L563 242L562 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M614 241L616 244L614 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M723 241L724 242L723 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M753 241L754 242L753 241M26 242L27 243L26 242M81 242L82 243L81 242M224 242L225 243L224 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M279 242L280 243L279 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M329 242L330 243L329 242M425 242L426 243L425 242M528 242L529 243L528 242M562 242L563 243L562 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M616 242L617 243L616 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M648 242L649 243L648 242M687 242L687 245L688 245L687 242M689 242L690 243L689 242M841 242L842 243L841 242M865 242L866 243L865 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M965 242L966 243L965 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M27 243L28 244L27 243M82 243L83 244L82 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M223 243L224 244L223 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M329 243L330 244L329 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M424 243L425 244L424 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M528 243L529 244L528 243M647 243L648 244L647 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M722 243L723 244L722 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M865 243L866 244L865 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M964 243L965 244L964 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M83 244L84 245L83 244M222 244L223 245L222 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M278 244L279 245L278 244M423 244L424 245L423 244M437 244L437 256L438 256L437 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M561 244L562 245L561 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M614 244L615 245L614 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M688 244L689 245L688 244M721 244L722 245L721 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M752 244L753 245L752 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M840 244L841 245L840 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M963 244L964 245L963 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M28 245L29 246L28 245M85 245L86 246L85 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M221 245L222 246L221 245M277 245L278 246L277 245M328 245L329 246L328 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M422 245L423 246L422 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M527 245L528 246L527 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M561 245L562 246L561 245M646 245L647 246L646 245M840 245L841 246L840 245M864 245L865 246L864 245M962 245L963 246L962 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M29 246L30 247L29 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M86 246L87 247L86 246M219 246L220 247L219 246M421 246L422 247L421 246M645 246L646 247L645 246M720 246L721 247L720 246M751 246L752 247L751 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M864 246L865 247L864 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M87 247L88 248L87 247M218 247L219 248L218 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M276 247L277 248L276 247M327 247L328 248L327 247M420 247L421 248L420 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M526 247L527 248L526 247M560 247L561 248L560 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M644 247L645 248L644 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M719 247L720 248L719 247M751 247L752 248L751 247M839 247L840 248L839 247M959 247L960 248L959 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M30 248L31 249L30 248M89 248L90 249L89 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M217 248L218 249L217 248M275 248L276 249L275 248M327 248L328 249L327 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M418 248L419 249L418 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M471 248L471 251L472 251L471 248M525 248L526 249L525 248M560 248L561 249L560 248M839 248L840 249L839 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M863 248L864 249L863 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M957 248L958 249L957 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M958 248L959 249L958 248M31 249L32 250L31 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M90 249L91 250L90 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M215 249L216 250L215 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M274 249L275 250L274 249M417 249L418 250L417 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M525 249L526 250L525 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M643 249L644 250L643 249M718 249L719 250L718 249M750 249L751 250L750 249M956 249L957 250L956 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M32 250L33 251L32 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M92 250L93 251L92 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M214 250L215 251L214 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M326 250L327 251L326 250M416 250L417 251L416 250M524 250L525 251L524 250M559 250L560 251L559 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M642 250L643 251L642 250M717 250L718 251L717 250M750 250L751 251L750 250M782 250L783 251L782 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M862 250L863 251L862 250M954 250L955 251L954 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M93 251L94 252L93 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M212 251L213 252L212 251M273 251L274 252L273 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M326 251L327 252L326 251M414 251L415 252L414 251M471 251L472 252L471 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M782 251L783 252L782 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M862 251L863 252L862 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M952 251L953 252L952 251M95 252L96 253L95 252M210 252L211 253L210 252M272 252L273 253L272 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M412 252L413 253L412 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M413 252L414 253L413 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M523 252L524 253L523 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M558 252L559 253L558 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M641 252L642 253L641 252M716 252L717 253L716 252M749 252L750 253L749 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M949 252L950 253L949 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M950 252L951 253L950 252M34 253L35 254L34 253M97 253L98 254L97 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M209 253L210 254L209 253M271 253L272 254L271 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M325 253L326 254L325 253M411 253L412 254L411 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M522 253L523 254L522 253M640 253L641 254L640 253M715 253L716 254L715 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M749 253L750 254L749 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M781 253L782 254L781 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M861 253L862 254L861 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M947 253L948 254L947 253M35 254L36 255L35 254M98 254L99 255L98 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M207 254L208 255L207 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M270 254L271 255L270 254M325 254L326 255L325 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M409 254L410 255L409 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M472 254L473 255L472 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M521 254L522 255L521 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M557 254L558 255L557 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M781 254L782 255L781 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M861 254L862 255L861 254M944 254L945 255L944 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M945 254L946 255L945 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M36 255L37 256L36 255M100 255L101 256L100 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M205 255L206 256L205 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M406 255L407 256L406 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M407 255L408 256L407 255M520 255L521 256L520 255M639 255L640 256L639 255M714 255L715 256L714 255M748 255L749 256L748 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M941 255L942 256L941 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M942 255L943 256L942 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M37 256L38 257L37 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M102 256L103 257L102 256M203 256L204 257L203 256M324 256L325 257L324 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M404 256L405 257L404 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M473 256L474 257L473 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M556 256L557 257L556 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M638 256L639 257L638 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M713 256L714 257L713 256M780 256L781 257L780 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M860 256L861 257L860 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M940 256L941 257L940 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M104 257L105 258L104 257M201 257L202 258L201 257M268 257L269 258L268 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M324 257L325 258L324 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M401 257L402 258L401 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M402 257L403 258L402 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M637 257L638 258L637 257M712 257L713 258L712 257M860 257L861 258L860 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M106 258L107 259L106 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M199 258L200 259L199 258M267 258L268 259L267 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M398 258L399 259L398 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M399 258L400 259L399 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M438 258L439 259L438 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M474 258L475 259L474 258M555 258L556 259L555 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M582 258L582 269L583 269L582 258M747 258L748 259L747 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M779 258L780 259L779 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M941 258L942 259L941 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M108 259L109 260L108 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M109 259L110 260L109 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M197 259L198 260L197 259M266 259L267 260L266 259M323 259L324 260L323 259M394 259L395 260L394 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M395 259L396 260L395 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M438 259L439 260L438 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M516 259L517 260L516 259M636 259L637 260L636 259M711 259L712 260L711 259M779 259L780 260L779 259M859 259L860 260L859 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M941 259L942 260L941 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M40 260L41 261L40 260M111 260L112 261L111 260M194 260L195 261L194 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M195 260L196 261L195 260M265 260L266 261L265 260M388.667 260.333L389.333 260.667L388.667 260.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M390.667 260.333L391.333 260.667L390.667 260.333M438.333 260.667L438.667 261.333L438.333 260.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M475 260L476 261L475 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M515 260L516 261L515 260M554 260L555 261L554 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M635 260L636 261L635 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M710 260L711 261L710 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M746 260L747 261L746 260M906 260L907 261L906 260M41 261L42 262L41 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M113 261L114 262L113 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M114 261L115 262L114 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M192 261L193 262L192 261M264 261L265 262L264 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M322 261L323 262L322 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M356 261L356 262L381 262L356 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M381 261L381 262L386 262L381 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M476 261L477 262L476 261M514 261L515 262L514 261M553 261L554 262L553 261M746 261L747 262L746 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M778 261L779 262L778 261M891 261L892 262L891 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M942 261L943 262L942 261M42 262L43 263L42 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M116 262L117 263L116 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M189 262L190 263L189 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M190 262L191 263L190 262M263 262L264 263L263 262M322 262L323 263L322 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M355 262L356 263L355 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M477 262L478 263L477 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M512 262L513 263L512 262M634 262L635 263L634 262M709 262L710 263L709 262M778 262L779 263L778 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M858 262L859 263L858 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M891 262L892 263L891 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M907 262L908 263L907 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M43 263L44 264L43 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M119 263L120 264L119 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M186 263L187 264L186 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M187 263L188 264L187 263M262 263L263 264L262 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M439 263L440 264L439 263M478 263L479 264L478 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M511 263L512 264L511 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M552 263L553 264L552 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M633 263L634 264L633 263M708 263L709 264L708 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M745 263L746 264L745 263M907 263L908 264L907 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M44 264L45 265L44 264M122 264L123 265L122 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M123 264L124 265L123 264M182 264L183 265L182 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M183 264L184 265L183 264M261 264L262 265L261 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M321 264L322 265L321 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M354 264L355 265L354 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M439 264L440 265L439 264M480 264L481 265L480 264M509 264L510 265L509 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M551 264L552 265L551 264M745 264L746 265L745 264M777 264L778 265L777 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M857 264L858 265L857 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M890 264L891 265L890 264M943 264L944 265L943 264M45 265L46 266L45 265M125.667 265.333L126.333 265.667L125.667 265.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M127 265L128 266L127 265M178.667 265.333L179.333 265.667L178.667 265.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M180 265L181 266L180 265M260 265L261 266L260 265M321 265L322 266L321 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M354 265L355 266L354 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M481 265L482 266L481 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M482 265L483 266L482 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M507 265L508 266L507 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M707 265L708 266L707 265M777 265L778 266L777 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M857 265L858 266L857 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M890 265L891 266L890 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M908 265L909 266L908 265M46 266L47 267L46 266M130 266L131 267L130 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M131.667 266.333L132.333 266.667L131.667 266.333M173.667 266.333L174.333 266.667L173.667 266.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M175.667 266.333L176.333 266.667L175.667 266.333M259 266L260 267L259 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M484 266L485 267L484 266M504 266L505 267L504 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M505 266L506 267L505 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M631 266L632 267L631 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M706 266L707 267L706 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M744 266L745 267L744 266M944 266L945 267L944 266M47 267L48 268L47 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M135.667 267.333L136.333 267.667L135.667 267.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M137 267L137 268L140 268L137 267M167 267L167 268L170 268L167 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M170 267L171 268L170 267M258 267L259 268L258 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M320 267L321 268L320 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M353 267L354 268L353 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M440 267L441 268L440 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M486 267L487 268L486 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M487.667 267.333L488.333 267.667L487.667 267.333M500 267L501 268L500 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M501 267L502 268L501 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M502 267L503 268L502 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M549 267L550 268L549 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M630 267L631 268L630 267M744 267L745 268L744 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M777 267L777 268L839 268L819 267L777 267M856 267L857 268L856 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M889 267L890 268L889 267M944 267L945 268L944 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M48 268L49 269L48 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M142 268L142 269L146 269L142 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M146 268L146 269L161 269L146 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M161 268L161 269L164 269L161 268M257 268L258 269L257 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M320 268L321 269L320 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M492 268L492 269L497 269L492 268M548 268L549 269L548 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M705 268L706 269L705 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M856 268L857 269L856 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M889 268L890 269L889 268M909 268L910 269L909 268M49 269L50 270L49 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M256 269L257 270L256 269M441 269L442 270L441 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M547 269L548 270L547 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M629 269L630 270L629 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M704 269L705 270L704 269M743 269L744 270L743 269M838 269L839 270L838 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M945 269L946 270L945 269M50 270L51 271L50 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M255 270L256 271L255 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M319 270L320 271L319 270M352 270L353 271L352 270M441 270L442 271L441 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M628 270L629 271L628 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M838 270L839 271L838 270M855 270L856 271L855 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M888 270L889 271L888 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M910 270L911 271L910 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M254 271L255 272L254 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M442 271L443 272L442 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M703 271L704 272L703 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M855 271L856 272L855 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M910 271L911 272L910 271M253 272L254 273L253 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M351 272L352 273L351 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M442 272L443 273L442 272M545 272L546 273L545 272M627 272L628 273L627 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M702 272L703 273L702 272M742 272L743 273L742 272M837 272L838 273L837 272M946 272L947 273L946 272M54 273L55 274L54 273M318 273L319 274L318 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M351 273L352 274L351 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M443 273L444 274L443 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M544 273L545 274L544 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M626 273L627 274L626 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M701 273L702 274L701 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M854 273L855 274L854 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M887 273L888 274L887 273M911 273L912 274L911 273M55 274L56 275L55 274M250 274L251 275L250 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M443 274L444 275L443 274M543 274L544 275L543 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M625 274L626 275L625 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M741 274L742 275L741 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M836 274L837 275L836 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M911 274L912 275L911 274M947 274L948 275L947 274M56 275L57 276L56 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M249 275L250 276L249 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M317 275L318 276L317 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M350 275L351 276L350 275M444 275L445 276L444 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M542 275L543 276L542 275M700 275L701 276L700 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M741 275L742 276L741 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M836 275L837 276L836 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M886 275L887 276L886 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M947 275L948 276L947 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M57 276L58 277L57 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M248 276L249 277L248 276M317 276L318 277L317 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M350 276L351 277L350 276M541 276L542 277L541 276M624 276L625 277L624 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M699 276L700 277L699 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M853 276L854 277L853 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M886 276L887 277L886 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M912 276L913 277L912 276M59 277L60 278L59 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M247 277L248 278L247 277M445 277L446 278L445 277M540 277L541 278L540 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M623 277L624 278L623 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M740 277L741 278L740 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M835 277L836 278L835 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M912 277L913 278L912 277M948 277L949 278L948 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M60 278L61 279L60 278M245 278L246 279L245 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M316 278L317 279L316 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M349 278L350 279L349 278M446 278L447 279L446 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M698 278L699 279L698 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M740 278L741 279L740 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M835 278L836 279L835 278M852 278L853 279L852 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M885 278L886 279L885 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M61 279L62 280L61 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M244 279L245 280L244 279M316 279L317 280L316 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M349 279L350 280L349 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M447 279L448 280L447 279M537 279L538 280L537 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M622 279L623 280L622 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M697 279L698 280L697 279M852 279L853 280L852 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M885 279L886 280L885 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M913 279L914 280L913 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M243 280L244 281L243 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M536 280L537 281L536 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M581 280L581 296L582 296L581 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M621 280L622 281L621 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M656 280L656 296L657 296L656 280M739 280L740 281L739 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M834 280L835 281L834 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M913 280L914 281L913 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M949 280L950 281L949 280M64 281L65 282L64 281M241 281L242 282L241 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M315 281L316 282L315 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M348 281L349 282L348 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M535 281L536 282L535 281M696 281L697 282L696 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M739 281L740 282L739 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M834 281L835 282L834 281M851 281L852 282L851 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M884 281L885 282L884 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M65 282L66 283L65 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M240 282L241 283L240 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M315 282L316 283L315 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M534 282L535 283L534 282M620 282L621 283L620 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M695 282L696 283L695 282M851 282L852 283L851 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M884 282L885 283L884 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M914 282L915 283L914 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M950 282L951 283L950 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M67 283L68 284L67 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M239 283L240 284L239 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M532 283L533 284L532 283M619 283L620 284L619 283M738 283L739 284L738 283M833 283L834 284L833 283M950 283L951 284L950 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M68 284L69 285L68 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M237 284L238 285L237 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M314 284L315 285L314 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M347 284L348 285L347 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M531 284L532 285L531 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M618 284L619 285L618 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M694 284L695 285L694 284M833 284L834 285L833 284M850 284L851 285L850 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M883 284L884 285L883 284M70 285L71 286L70 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M236 285L237 286L236 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M529 285L530 286L529 285M693 285L694 286L693 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M850 285L851 286L850 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M915 285L916 286L915 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M951 285L952 286L951 285M71 286L72 287L71 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M234 286L235 287L234 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M346 286L347 287L346 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M454 286L455 287L454 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M528 286L529 287L528 286M617 286L618 287L617 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M737 286L738 287L737 286M832 286L833 287L832 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M951 286L952 287L951 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M73 287L74 288L73 287M232 287L233 288L232 287M313 287L314 288L313 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M346 287L347 288L346 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M455 287L456 288L455 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M526 287L527 288L526 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M616 287L617 288L616 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M692 287L693 288L692 287M849 287L850 288L849 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M882 287L883 288L882 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M916 287L917 288L916 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M74 288L75 289L74 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M75 288L76 289L75 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M231 288L232 289L231 288M456 288L457 289L456 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M524 288L525 289L524 288M691 288L692 289L691 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M736 288L737 289L736 288M916 288L917 289L916 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M952 288L953 289L952 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M76 289L77 290L76 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M229 289L230 290L229 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M312 289L313 290L312 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M345 289L346 290L345 289M458 289L459 290L458 289M522 289L523 290L522 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M615 289L616 290L615 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M690 289L691 290L690 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M736 289L737 290L736 289M831 289L832 290L831 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M881 289L882 290L881 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M78 290L79 291L78 290M227 290L228 291L227 290M312 290L313 291L312 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M345 290L346 291L345 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M460 290L461 291L460 290M520 290L521 291L520 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M521 290L522 291L521 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M614 290L615 291L614 290M848 290L849 291L848 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M881 290L882 291L881 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M917 290L918 291L917 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M953 290L954 291L953 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M80 291L81 292L80 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M226 291L227 292L226 291M461 291L462 292L461 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M518 291L519 292L518 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M689 291L690 292L689 291M735 291L736 292L735 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M830 291L831 292L830 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M917 291L918 292L917 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M953 291L954 292L953 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M81 292L82 293L81 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M82 292L83 293L82 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M224 292L225 293L224 292M311 292L312 293L311 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M344 292L345 293L344 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M463 292L464 293L463 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M464 292L465 293L464 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M515 292L516 293L515 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M516 292L517 293L516 292M613 292L614 293L613 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M688 292L689 293L688 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M735 292L736 293L735 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M830 292L831 293L830 292M847 292L848 293L847 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M880 292L881 293L880 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M83 293L84 294L83 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M84 293L85 294L84 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M222 293L223 294L222 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M311 293L312 294L311 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M344 293L345 294L344 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M466 293L467 294L466 293M513 293L514 294L513 293M612 293L613 294L612 293M847 293L848 294L847 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M880 293L881 294L880 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M918 293L919 294L918 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M954 293L955 294L954 293M85 294L86 295L85 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M86 294L87 295L86 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M220 294L221 295L220 294M468 294L469 295L468 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M469 294L470 295L469 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M509 294L510 295L509 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M510 294L511 295L510 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M611 294L612 295L611 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M687 294L688 295L687 294M734 294C738.071 298.659 753.015 296 759 296L830 296L830 295L767 295L734 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M829 294L830 295L829 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M918 294L919 295L918 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M954 294L955 295L954 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M87 295L88 296L87 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M88 295L89 296L88 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M218 295L219 296L218 295M311 295L311 296L344 296L311 295M471 295L472 296L471 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M472 295L473 296L472 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M505 295L506 296L505 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M506 295L507 296L506 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M507 295L508 296L507 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M686 295L687 296L686 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M847 295L847 296L880 296L847 295M919 295L919 296L955 296C945.44 291.989 929.387 295 919 295M89 296L90 297L89 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M90 296L91 297L90 296M215 296L216 297L215 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M216 296L217 297L216 296M475.667 296.333L476.333 296.667L475.667 296.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M477 296L478 297L477 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4389",
      stroke: "none"
    },
    d: "M478 296L479 297L478 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M500.667 296.333L501.333 296.667L500.667 296.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M502.667 296.333L503.333 296.667L502.667 296.333M582 296L582 297L610 297L582 296M657 296L657 297L686 297L657 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M92 297L93 298L92 297M213 297L214 298L213 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M214 297L215 298L214 297M481 297L481 298L486 298L481 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M486 297L486 298L492 298L486 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M492 297L492 298L498 298L492 297M94 298L95 299L94 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M95 298L96 299L95 298M211 298L212 299L211 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M96 299L97 300L96 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M97 299L98 300L97 299M208 299L209 300L208 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M209 299L210 300L209 299M99 300L100 301L99 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M100 300L101 301L100 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M206 300L207 301L206 300M102 301L103 302L102 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M203 301L204 302L203 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M204 301L205 302L204 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M105 302L106 303L105 302M200 302L201 303L200 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M201 302L202 303L201 302M108 303L109 304L108 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M109 303L110 304L109 303M197 303L198 304L197 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M198 303L199 304L198 303M111 304L112 305L111 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M112 304L113 305L112 304M193 304L194 305L193 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M194 304L195 305L194 304M115 305L116 306L115 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M116 305L117 306L116 305M189 305L190 306L189 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M190.667 305.333L191.333 305.667L190.667 305.333M119 306L120 307L119 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M120 306L121 307L120 306M185 306L186 307L185 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M186.667 306.333L187.333 306.667L186.667 306.333M123.667 307.333L124.333 307.667L123.667 307.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M125.667 307.333L126.333 307.667L125.667 307.333M180 307L181 308L180 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M181.667 307.333L182.333 307.667L181.667 307.333M129.667 308.333L130.333 308.667L129.667 308.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M131.667 308.333L132.333 308.667L131.667 308.333M173.667 308.333L174.333 308.667L173.667 308.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M175 308L175 309L178 309L175 308M136 309L136 310L140 310L136 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76839b",
      stroke: "none"
    },
    d: "M140 309L140 310L144 310L140 309M162 309L162 310L166 310L162 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a6ac",
      stroke: "none"
    },
    d: "M166 309L166 310L170 310L166 309z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpLogoWhite);
export default __webpack_public_path__ + "static/media/SP-logo-white.274b2a386e402166b66970df9108119e.svg";
export { ForwardRef as ReactComponent };